import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Grid, TextField, Typography, Button, FormControl, makeStyles, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Switch, CircularProgress, withStyles, MenuItem, Divider, Select, IconButton } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Check } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { inputFieldStyles, commonInlineStyles } from "../../styles";
import axios from "axios";
import { appUrl } from "../../../../../../../utils/config";
import { Country, State, City } from 'country-state-city';
import postalCodes from 'postal-codes-js';
import { useApiBaseUrl } from "../../../CommonMethods/CommonMethods";



const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 44,
    height: 22,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "& .MuiSwitch-track": {
      backgroundColor: "#c6c6c6 !important",
    },
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#1890ff !important",
        opacity: 1,
        border: "none",
      },
      "& .MuiSwitch-track": {
        backgroundColor: "#1890ff !important",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 18,
    height: 18,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: "#c6c6c6",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    disabled={props.disabled}
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
));

const useStyles = makeStyles((theme) => ({
  formTitle: {
    marginBottom: theme.spacing(4),
    fontWeight: 700,
    fontSize: 32,
    position: 'relative',
  },
  formField: {
    width: "100%",
    // marginBottom: theme.spacing(3),
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
    },
  },
  button: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
  },
  backButton: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
    background: '#707070',
    color: '#fff',
    marginRight: theme.spacing(2),
  },
  tabRoot: {
    minHeight: 36,
  },
  tabLabel: {
    fontWeight: 600,
    fontSize: 16,
    textTransform: 'none',
  },
  table: {
    minWidth: 400,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  tableHead: {
    backgroundColor: '#f9f9fc',
  },
  tableCell: {
    fontSize: 16,
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  tabContentContainer: {
    minHeight: 200,
    maxWidth: 835,
    marginTop: 20
  },
  iosSwitch: {
    '& > *': {
      height: '22px !important',
    },
    '& .MuiSwitch-switchBase .MuiSwitch-track': {
      backgroundColor: '#c6c6c6 !important',
    },
    '& .MuiSwitch-switchBase': {
      left: '2px',
      top: '-1px',
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      left: 'auto',
      right: '18px',
    },
    '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-track': {
      backgroundColor: '#1890ff !important',
    },
  },
  checkedSwitch: {
    position: 'absolute',
    width: '16px !important',
    left: '12px',
    top: '-3px',
    color: 'white',
  }
}));


// Product Modality Tab Component
const ProductModalityTab = ({ drugTypes, selectedConfigs, onToggle, readOnly = false, isLoading = false }) => {
  const classes = useStyles();
  //console.log("drug types is here",drugTypes);

  if (isLoading) {
    return (
      <div className={classes.loaderContainer}>
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (!drugTypes || drugTypes.length === 0) {
    return <Typography>No product modality types available</Typography>;
  }

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableCell}>Selection</TableCell>
            <TableCell className={classes.tableCell}>Product Modality</TableCell>
            <TableCell className={classes.tableCell}>Product Modality ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {drugTypes.map((type, idx) => (
            <TableRow key={type.drugTypeID}>
              <TableCell>
                <span style={{ position: "relative" }}>
                  <IOSSwitch
                    className={classes.iosSwitch}
                    checked={selectedConfigs[idx] === true}
                    onChange={() => onToggle(idx)}
                    color="primary"
                    disabled={readOnly}
                  />
                  {selectedConfigs[idx] && <Check className={classes.checkedSwitch} />}
                </span>
              </TableCell>
              <TableCell>{type.drugTypeName}</TableCell>
              <TableCell>{type.drugTypeID}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// Manufacturing Supply Type Tab Component
const ManufacturingSupplyTypeTab = ({ supplyTypes, selectedConfigs, onToggle, readOnly = false, isLoading = false }) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classes.loaderContainer}>
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (!supplyTypes || supplyTypes.length === 0) {
    return <Typography>No manufacturing supply types available</Typography>;
  }

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableCell}>Selection</TableCell>
            <TableCell className={classes.tableCell}>Manufacturing Supply Type</TableCell>
            <TableCell className={classes.tableCell}>Manufacturing Supply Type ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {supplyTypes.map((type, idx) => (
            <TableRow key={type.supplyTypeID}>
              <TableCell>
                <span style={{ position: "relative" }}>
                  <IOSSwitch
                    className={classes.iosSwitch}
                    checked={selectedConfigs[idx] === true}
                    onChange={() => onToggle(idx)}
                    color="primary"
                    disabled={readOnly}
                  />
                  {selectedConfigs[idx] && <Check className={classes.checkedSwitch} />}
                </span>
              </TableCell>
              <TableCell>{type.supplyTypeName}</TableCell>
              <TableCell>{type.supplyTypeID}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// Plant Type Tab Component
const PlantTypeTab = ({ plantTypes, selectedConfigs, onToggle, readOnly = false, isLoading = false }) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classes.loaderContainer}>
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (!plantTypes || plantTypes.length === 0) {
    return <Typography>No plant types available</Typography>;
  }

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableCell}>Selection</TableCell>
            <TableCell className={classes.tableCell}>Plant Type</TableCell>
            <TableCell className={classes.tableCell}>Plant Type ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {plantTypes.map((type, idx) => (
            <TableRow key={type.plantTypeID}>
              <TableCell>
                <span style={{ position: "relative" }}>
                  <IOSSwitch
                    className={classes.iosSwitch}
                    checked={selectedConfigs[idx] === true}
                    onChange={() => onToggle(idx)}
                    color="primary"
                    disabled={readOnly}
                  />
                  {selectedConfigs[idx] && <Check className={classes.checkedSwitch} />}
                </span>
              </TableCell>
              <TableCell>{type.plantTypeName}</TableCell>
              <TableCell>{type.plantTypeID}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// Manufacturing Plant Type Tab Component
const ManufacturingPlantTypeTab = ({ facilityTypes, selectedConfigs, onToggle, readOnly = false, isLoading = false }) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classes.loaderContainer}>
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (!facilityTypes || facilityTypes.length === 0) {
    return <Typography>No manufacturing plant types available</Typography>;
  }

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableCell}>Selection</TableCell>
            <TableCell className={classes.tableCell}>Manufacturing Plant Type</TableCell>
            <TableCell className={classes.tableCell}>Manufacturing Plant Type ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {facilityTypes.map((type, idx) => (
            <TableRow key={type.facilityTypeID}>
              <TableCell>
                <span style={{ position: "relative" }}>
                  <IOSSwitch
                    className={classes.iosSwitch}
                    checked={selectedConfigs[idx] === true}
                    onChange={() => onToggle(idx)}
                    color="primary"
                    disabled={readOnly}
                  />
                  {selectedConfigs[idx] && <Check className={classes.checkedSwitch} />}
                </span>
              </TableCell>
              <TableCell>{type.facilityTypeName}</TableCell>
              <TableCell>{type.facilityTypeID}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const PlantDetails = (props) => {
  const { updateStepData, handleNext, handleBack, handleSubmit, formData, readOnly = false, onFieldChange, hideStepActions = false, selectedCMOFormData, originalVendorPlantDetails, activeStep, stepsLength, navigatedBackToPlantDetails = false, onNavigatedBackHandled } = props;
  //console.log("PlantDetails - formData:", formData);
  //console.log("PlantDetails - formData.cmoSites:", formData?.cmoSites); 
  // Get the best available data source - prioritize direct API response
  const dataSource = originalVendorPlantDetails?.vendorPlantDetails?.vendorPlantDetails || selectedCMOFormData?.vendorPlantDetails || formData || {};
  
  const classes = useStyles();
  const API_BASE_URL = useApiBaseUrl(appUrl)
  
 
  const [tabIndex, setTabIndex] = useState(0);
  

  const [manufacturingPlantTabIndex, setManufacturingPlantTabIndex] = useState(0);
  
  
  const [unlockedTabs, setUnlockedTabs] = useState([true]);
  
  
  const [plantsInitialized, setPlantsInitialized] = useState(false);
  
  // Use ref to track previous activeStep to detect navigation
  const prevActiveStepRef = useRef(activeStep);
  
  // Ref for scrolling to top of section
  const plantDetailsSectionRef = useRef(null);
  
  // Initialize manufacturing plants from formData/dataSource
  const initializeManufacturingPlants = () => {
    
    const sourceData = readOnly 
      ? dataSource
      : (dataSource?.cmoSites && Array.isArray(dataSource.cmoSites) && dataSource.cmoSites.length > 0) 
        ? dataSource 
        : (formData?.cmoSites && Array.isArray(formData.cmoSites) && formData.cmoSites.length > 0)
          ? formData
          : dataSource;
    
    
    
    
    if (sourceData?.cmoSites && Array.isArray(sourceData.cmoSites) && sourceData.cmoSites.length > 0) {
      const allPlants = [];
      
      // Helper function to normalize address data
      const normalizeAddress = (address) => {
        if (!address) return {
          addressLine1: '',
          addressLine2: '',
          country: '',
          state: '',
          city: '',
          zipCode: ''
        };
        return {
          addressLine1: address.addressLine1 || '',
          addressLine2: address.addressLine2 || '',
          country: address.country || '',
          state: address.state || '',
          city: address.city || '',
          zipCode: address.zipCode || ''
        };
      };
      
      sourceData.cmoSites.forEach((site) => {
       
        const siteID = site?.siteDetails?.siteID || site?.siteID || '';
        const siteShortName = site?.siteDetails?.siteShortName || site?.siteShortName || '';
        
        const siteManufacturingPlants = site?.manufacturingPlantDataList || site?.siteManufacturingPlants || [];
        
        //console.log(`Processing site: ${siteID}, plants count: ${siteManufacturingPlants.length}`);
        
        siteManufacturingPlants.forEach((plant) => {
          
          const mfgPlantID = plant?.mfgPlantDetails?.mfgPlantID || plant?.mfgPlantID || '';
          const mfgPlantShortName = plant?.mfgPlantDetails?.mfgPlantShortName || plant?.mfgPlantShortName || '';
          
          //console.log(`  - Plant: ${mfgPlantID} (${mfgPlantShortName})`);
          
          allPlants.push({
            siteID: siteID,
            siteShortName: siteShortName,
            manufacturingPlantID: mfgPlantID,
            manufacturingPlantShortName: mfgPlantShortName,
            aslNumber: plant?.mfgPlantDetails?.aslNumber || plant?.aslNumber || '',
            // Check lineDetailsList first (API format), then lineSuites (siteRows format)
            lineSuites: plant?.lineDetailsList?.map(ls => ({
              lineSuiteID: ls.lineID || ls.lineSuiteID || '',
              lineSuiteShortName: ls.lineShortName || ls.lineSuiteShortName || ''
            })) || plant?.lineSuites || [
              { lineSuiteID: '', lineSuiteShortName: '' }
            ],
            // Addresses per plant
            mainAddress: normalizeAddress(plant?.mainAddress),
            pickupAddress: normalizeAddress(plant?.pickupAddress),
            deliveryAddress: normalizeAddress(plant?.deliveryAddress),
            
            plantDrugTypeIDs: plant?.drugTypeIDList?.map(item => Number(item.drugTypeID || item)) || [],
            plantSupplyTypeIDs: plant?.supplyTypeIDList?.map(item => Number(item.supplyTypeID || item)) || [],
            plantPlantTypeIDs: plant?.plantTypeIDList?.map(item => Number(item.plantTypeID || item)) || [],
            plantFacilityTypeIDs: plant?.facilityTypeIDList?.map(item => Number(item.facilityTypeID || item)) || [],
            // Configurations per plant - will be initialized when types are loaded with all items ON
            configurations: plant?.configurations || null,
            // Freight forwarder — map from API response so eye/edit shows the saved FF.
            // Response key is `freightForwardersDetails` (plural); field spellings differ.
            freightForwarder: (() => {
              const ffd = plant?.freightForwardersDetails || plant?.freightForwarderDetails || {};
              return {
                id: ffd.freightForwarderID || '',
                name: ffd.freightForwarderName || '',
                portal: ffd.portal || '',
                billingCenter: ffd.billingCentreForShipment || ffd.billingCenterForShipment || '',
                collabrixFreightForwarderID:
                  ffd.collabribrixFreightForwarderID || ffd.collabrixFreightForwarderID || null,
              };
            })(),
          });
        });
      });
      
      //console.log("initializeManufacturingPlants - allPlants:", allPlants);
      if (allPlants.length > 0) {
        return allPlants;
      }
    }
    
    return [];
  };
  
  const [manufacturingPlants, setManufacturingPlants] = useState(initializeManufacturingPlants());

  // Filter manufacturing plants to only show those not marked for delete (for tabs display)
  const visibleManufacturingPlants = useMemo(() => {
    return manufacturingPlants
      .map((plant, originalIndex) => ({ ...plant, originalIndex }))
      .filter(plant => plant.markForDelete !== true);
  }, [manufacturingPlants]);

  
  const getOriginalPlantIndex = (visibleIndex) => {
    return visibleManufacturingPlants[visibleIndex]?.originalIndex ?? visibleIndex;
  };

  
  const getVisibleTabIndex = (originalIndex) => {
    return visibleManufacturingPlants.findIndex(plant => plant.originalIndex === originalIndex);
  };

  // Reset to first visible tab if current tab is marked for delete
  useEffect(() => {
    if (visibleManufacturingPlants.length > 0) {
      const currentPlantVisible = visibleManufacturingPlants.some(
        plant => plant.originalIndex === manufacturingPlantTabIndex
      );
      if (!currentPlantVisible) {
        // Switch to the first visible plant
        setManufacturingPlantTabIndex(visibleManufacturingPlants[0].originalIndex);
      }
    }
  }, [visibleManufacturingPlants, manufacturingPlantTabIndex]);
  
  // Initialize selectedConfigs using dataSource data
  const initializeSelectedConfigs = () => {
    // Return empty arrays initially - will be populated when types are loaded
    return {
      productModality: [],
      manufacturingSupplyType: [],
      plantType: [],
      manufacturingPlantType: [],
    };
  };
  
  const [selectedConfigs, setSelectedConfigs] = useState(initializeSelectedConfigs());
  
  const [configsInitialized, setConfigsInitialized] = useState(false);
  
  // Initialize stepData using dataSource data  
  const initializeStepData = () => {
    // In read-only mode, ONLY use dataSource (API response)
    // In edit mode, prefer formData (for back navigation), fallback to dataSource
    const sourceData = readOnly 
      ? dataSource 
      : (Object.keys(formData).length > 0) ? formData : dataSource;
    
    // Helper function to normalize address data from API response
    const normalizeAddress = (address) => {
      if (!address) return {
        addressLine1: '',
        addressLine2: '',
        country: '',
        state: '',
        city: '',
        zipCode: ''
      };
      
      return {
        addressLine1: address.addressLine1 || '',
        addressLine2: address.addressLine2 || '',
        country: address.country || '',
        state: address.state || '',
        city: address.city || '',
        zipCode: address.zipCode || ''
      };
    };
    
    if (readOnly) {
      // View mode - use API response only
      return {
        ...sourceData,
        mainAddress: normalizeAddress(sourceData?.mainAddress),
        pickupAddress: normalizeAddress(sourceData?.pickupAddress),
        deliveryAddress: normalizeAddress(sourceData?.deliveryAddress)
      };
    } else {
      // Edit mode - use formData (for back navigation)
      return {
        ...formData,
        mainAddress: normalizeAddress(sourceData?.mainAddress),
        pickupAddress: normalizeAddress(sourceData?.pickupAddress),
        deliveryAddress: normalizeAddress(sourceData?.deliveryAddress)
      };
    }
  };
  
  // Get current plant's data (addresses and configs are now per-plant)
  const getCurrentPlant = () => {
    return manufacturingPlants[manufacturingPlantTabIndex] || null;
  };

  const getCurrentPlantAddresses = () => {
    const plant = getCurrentPlant();
    if (!plant) {
      return {
        mainAddress: { addressLine1: '', addressLine2: '', country: '', state: '', city: '', zipCode: '' },
        pickupAddress: { addressLine1: '', addressLine2: '', country: '', state: '', city: '', zipCode: '' },
        deliveryAddress: { addressLine1: '', addressLine2: '', country: '', state: '', city: '', zipCode: '' }
      };
    }
    return {
      mainAddress: plant.mainAddress || { addressLine1: '', addressLine2: '', country: '', state: '', city: '', zipCode: '' },
      pickupAddress: plant.pickupAddress || { addressLine1: '', addressLine2: '', country: '', state: '', city: '', zipCode: '' },
      deliveryAddress: plant.deliveryAddress || { addressLine1: '', addressLine2: '', country: '', state: '', city: '', zipCode: '' }
    };
  };

  const getCurrentPlantConfigs = () => {
    const plant = getCurrentPlant();
    return plant?.configurations || {
      productModality: [],
      manufacturingSupplyType: [],
      plantType: [],
      manufacturingPlantType: [] 
    };
  };

  // Keep stepData for backward compatibility but it will use current plant's data
  const [stepData, setStepData] = useState(() => {
    const initial = initializeStepData();
    // Initialize with first plant's addresses if available
    if (manufacturingPlants.length > 0 && manufacturingPlants[0]) {
      return {
        ...initial,
        mainAddress: manufacturingPlants[0].mainAddress || initial.mainAddress,
        pickupAddress: manufacturingPlants[0].pickupAddress || initial.pickupAddress,
        deliveryAddress: manufacturingPlants[0].deliveryAddress || initial.deliveryAddress
      };
    }
    return initial;
  });
  
  const [loading, setLoading] = useState(false);
  const [tabsLoading, setTabsLoading] = useState(true);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const [facilityTypes, setFacilityTypes] = useState([]);
  const [supplyTypes, setSupplyTypes] = useState([]);
  const [drugTypes, setDrugTypes] = useState([]);
  const [plantTypes, setPlantTypes] = useState([]);
  // const [states, setStates] = useState([]);
  // const [cities, setCities] = useState([]);
  const [postalCodeErrors, setPostalCodeErrors] = useState({
    mainAddress: '',
    pickupAddress: '',
    deliveryAddress: ''
  });

  // Track which tabs have been visited
  const tabCount = 4;
  const [tabsVisited, setTabsVisited] = useState([true, ...Array(tabCount - 1).fill(false)]);

  const cmoDetailsResponse = JSON.parse(sessionStorage.getItem("cmoDetailsResponse"));
  const [brandOwnerMosymphonyID, setBrandOwnerMosymphonyID] = useState("");


  // Update tabsVisited when a tab is clicked
  const handleTabChange = (e, newValue) => {
    setTabIndex(newValue);
    setTabsVisited((prev) => {
      const updated = [...prev];
      updated[newValue] = true;
      return updated;
    });
  };

  // Handle manufacturing plant tab change - sync addresses and configs
  const handleManufacturingPlantTabChange = (e, newValue) => {
    // Convert visible tab index to original plant index
    const originalIndex = getOriginalPlantIndex(newValue);
    
    // Prevent switching to locked tabs (first tab is always unlocked), but allow all tabs in readOnly mode
    if (!readOnly && originalIndex > 0 && !unlockedTabs[originalIndex]) {
      return;
    }
    
    setManufacturingPlantTabIndex(originalIndex);
    // Reset configuration sub-tabs to first tab when switching manufacturing plants
    setTabIndex(0);
    
    // Update stepData with new plant's addresses
    const newPlant = manufacturingPlants[originalIndex];
    if (newPlant) {
      setStepData(prev => ({
        ...prev,
        mainAddress: newPlant.mainAddress || prev.mainAddress,
        pickupAddress: newPlant.pickupAddress || prev.pickupAddress,
        deliveryAddress: newPlant.deliveryAddress || prev.deliveryAddress
      }));
      
      // Update selectedConfigs with new plant's configurations
      if (newPlant.configurations) {
        setSelectedConfigs(newPlant.configurations);
      }
    }
  };

  // Helper function to rebuild cmoSites structure from manufacturingPlants
  const rebuildCmoSitesFromPlants = (plants) => {
    // Get existing cmoSites to preserve collabrix IDs
    // In read-only mode, ONLY use dataSource (API response)
    // In edit mode, prefer formData (for back navigation with preserved edits), fallback to dataSource
    const sourceData = readOnly 
      ? dataSource 
      : (formData?.cmoSites && formData.cmoSites.length > 0) ? formData : dataSource;
    const existingCmoSites = sourceData?.cmoSites || [];
    
    // Group plants by siteID
    const sitesMap = new Map();
    
    plants.forEach((plant) => {
      const siteID = plant.siteID || '';
      if (!sitesMap.has(siteID)) {
        // Find existing site to preserve collabrix IDs
        const existingSite = existingCmoSites.find(
          s => (s?.siteDetails?.siteID || s?.siteID) === siteID
        );
        
        sitesMap.set(siteID, {
          siteID: siteID,
          siteShortName: plant.siteShortName || '',
          collabrixCMOSiteID: plant.collabrixCMOSiteID || existingSite?.siteDetails?.collabrixCMOSiteID || existingSite?.collabrixCMOSiteID,
          plants: []
        });
      }
      sitesMap.get(siteID).plants.push(plant);
    });
    
    // Convert to cmoSites array format
    return Array.from(sitesMap.values()).map((siteGroup) => ({
      siteDetails: {
        collabrixCMOSiteID: siteGroup.collabrixCMOSiteID,
        siteID: siteGroup.siteID,
        siteShortName: siteGroup.siteShortName,
        markForDelete: false
      },
      manufacturingPlantDataList: siteGroup.plants.map((plant) => ({
        mfgPlantDetails: {
          collabrixCMOSiteID: plant.collabrixCMOSiteID,
          collabrixMfgPlantID: plant.collabrixMfgPlantID,
          mfgPlantID: plant.manufacturingPlantID || '',
          mfgPlantShortName: plant.manufacturingPlantShortName || '',
          aslNumber: plant.aslNumber || '',
          markForDelete: false
        },
        lineDetailsList: (plant.lineSuites || []).map(ls => ({
          lineID: ls.lineSuiteID || '',
          lineShortName: ls.lineSuiteShortName || ''
        })),
        mainAddress: plant.mainAddress || {},
        pickupAddress: plant.pickupAddress || {},
        deliveryAddress: plant.deliveryAddress || {},
        configurations: plant.configurations
      }))
    }));
  };

  // Handle adding a new line/suite
  const handleAddLineSuite = (plantIndex) => {
    const updatedPlants = [...manufacturingPlants];
    if (!updatedPlants[plantIndex].lineSuites) {
      updatedPlants[plantIndex].lineSuites = [];
    }
    updatedPlants[plantIndex].lineSuites.push({
      lineSuiteID: '',
      lineSuiteShortName: ''
    });
    setManufacturingPlants(updatedPlants);
    
    // Rebuild cmoSites structure from updated plants to persist changes
    const updatedCmoSites = rebuildCmoSitesFromPlants(updatedPlants);
    updateStepData({ 
      ...stepData, 
      manufacturingPlants: updatedPlants,
      cmoSites: updatedCmoSites 
    });
  };

  // Handle removing a line/suite
  const handleRemoveLineSuite = (plantIndex, lineSuiteIndex) => {
    const updatedPlants = [...manufacturingPlants];
    if (updatedPlants[plantIndex].lineSuites && updatedPlants[plantIndex].lineSuites.length > 1) {
      updatedPlants[plantIndex].lineSuites.splice(lineSuiteIndex, 1);
      setManufacturingPlants(updatedPlants);
      
      // Rebuild cmoSites structure from updated plants to persist changes
      const updatedCmoSites = rebuildCmoSitesFromPlants(updatedPlants);
      updateStepData({ 
        ...stepData, 
        manufacturingPlants: updatedPlants,
        cmoSites: updatedCmoSites 
      });
    }
  };

  // Handle line/suite field change with uniqueness validation
  const handleLineSuiteChange = (plantIndex, lineSuiteIndex, field, value) => {
    const updatedPlants = [...manufacturingPlants];
    if (!updatedPlants[plantIndex].lineSuites) {
      updatedPlants[plantIndex].lineSuites = [];
    }
    if (!updatedPlants[plantIndex].lineSuites[lineSuiteIndex]) {
      updatedPlants[plantIndex].lineSuites[lineSuiteIndex] = { lineSuiteID: '', lineSuiteShortName: '' };
    }
    
    // If changing lineSuiteID, validate uniqueness (using trimmed value for comparison to ignore leading/trailing spaces)
    if (field === 'lineSuiteID') {
      const trimmedValue = value.trim();
      if (trimmedValue !== '') {
        const currentLineSuites = updatedPlants[plantIndex].lineSuites;
        const isDuplicate = currentLineSuites.some((ls, idx) => 
          idx !== lineSuiteIndex && ls.lineSuiteID && ls.lineSuiteID.trim().toLowerCase() === trimmedValue.toLowerCase()
        );
        
        if (isDuplicate) {
          setErrors(prev => ({
            ...prev,
            [`manufacturingPlant_${plantIndex}_lineSuite_${lineSuiteIndex}_lineSuiteID`]: 'Line/Suite ID must be unique'
          }));
          return; 
        } else {
          setErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[`manufacturingPlant_${plantIndex}_lineSuite_${lineSuiteIndex}_lineSuiteID`];
            return newErrors;
          });
        }
      }
    }
    
    // Save the value (spaces in middle are preserved, leading/trailing are trimmed on blur)
    updatedPlants[plantIndex].lineSuites[lineSuiteIndex][field] = value;
    setManufacturingPlants(updatedPlants);

    // Rebuild cmoSites structure from updated plants to persist changes
    const updatedCmoSites = rebuildCmoSitesFromPlants(updatedPlants);
    updateStepData({
      ...stepData,
      manufacturingPlants: updatedPlants,
      cmoSites: updatedCmoSites
    });
  };

  // BCM-3PL: Freight Forwarder Details (one per Manufacturing Plant).
  // UI-only for now — API integration to follow once backend contract is shared.
  // Fields: id (numeric), name (text), portal (URL), billingCenter (numeric)
  // — matches the 4 columns shown in the Logistics dashboard.
  const handleFreightForwarderChange = (plantIndex, field, value) => {
    const updatedPlants = [...manufacturingPlants];
    if (!updatedPlants[plantIndex].freightForwarder) {
      updatedPlants[plantIndex].freightForwarder = { id: '', name: '', portal: '', billingCenter: '' };
    }
    updatedPlants[plantIndex].freightForwarder = {
      ...updatedPlants[plantIndex].freightForwarder,
      [field]: value
    };
    setManufacturingPlants(updatedPlants);

    const updatedCmoSites = rebuildCmoSitesFromPlants(updatedPlants);
    updateStepData({
      ...stepData,
      manufacturingPlants: updatedPlants,
      cmoSites: updatedCmoSites
    });
  };



  useEffect(() => {
   
    // In read-only mode (view mode), ONLY use dataSource (API response)
    // In edit mode, prioritize formData (for back navigation with preserved edits), fallback to dataSource
    const sourceData = readOnly 
      ? dataSource
      : (formData?.cmoSites && Array.isArray(formData.cmoSites) && formData.cmoSites.length > 0)
        ? formData
        : (dataSource?.cmoSites && Array.isArray(dataSource.cmoSites) && dataSource.cmoSites.length > 0) 
          ? dataSource 
          : formData; 
    
    // Helper function to normalize address data
    const normalizeAddress = (address) => {
      if (!address) return {
        addressLine1: '',
        addressLine2: '',
        country: '',
        state: '',
        city: '',
        zipCode: ''
      };
      return {
        addressLine1: address.addressLine1 || '',
        addressLine2: address.addressLine2 || '',
        country: address.country || '',
        state: address.state || '',
        city: address.city || '',
        zipCode: address.zipCode || ''
      };
    };
    
   
    if (sourceData?.cmoSites && Array.isArray(sourceData.cmoSites) && sourceData.cmoSites.length > 0) {
      const allPlants = [];
      
      sourceData.cmoSites.forEach((site) => {
        
        const siteID = site?.siteDetails?.siteID || site?.siteID || '';
        const siteShortName = site?.siteDetails?.siteShortName || site?.siteShortName || '';
        // Check manufacturingPlantDataList first (API format), then siteManufacturingPlants (siteRows format)
        const siteManufacturingPlants = site?.manufacturingPlantDataList || site?.siteManufacturingPlants || [];
        
        siteManufacturingPlants.forEach((plant) => {
         
          const mfgPlantID = plant?.mfgPlantDetails?.mfgPlantID || plant?.mfgPlantID || '';
          const mfgPlantShortName = plant?.mfgPlantDetails?.mfgPlantShortName || plant?.mfgPlantShortName || '';
          
          // Extract collabrix IDs to preserve them
          const collabrixMfgPlantID = plant?.mfgPlantDetails?.collabrixMfgPlantID || plant?.collabrixMfgPlantID;
          const collabrixCMOSiteID = plant?.mfgPlantDetails?.collabrixCMOSiteID || plant?.collabrixCMOSiteID || site?.siteDetails?.collabrixCMOSiteID || site?.collabrixCMOSiteID;
          
          allPlants.push({
            siteID: siteID,
            siteShortName: siteShortName,
            collabrixCMOSiteID: collabrixCMOSiteID,
            manufacturingPlantID: mfgPlantID,
            manufacturingPlantShortName: mfgPlantShortName,
            collabrixMfgPlantID: collabrixMfgPlantID,
            aslNumber: plant?.mfgPlantDetails?.aslNumber || plant?.aslNumber || '',
            // Check lineDetailsList first (API format), then lineSuites (siteRows format)
            lineSuites: plant?.lineDetailsList?.map(ls => ({
              lineSuiteID: ls.lineID || ls.lineSuiteID || '',
              lineSuiteShortName: ls.lineShortName || ls.lineSuiteShortName || ''
            })) || plant?.lineSuites || [
              { lineSuiteID: '', lineSuiteShortName: '' }
            ],
            // Addresses per plant
            mainAddress: normalizeAddress(plant?.mainAddress),
            pickupAddress: normalizeAddress(plant?.pickupAddress),
            deliveryAddress: normalizeAddress(plant?.deliveryAddress),
            // Store ID lists from backend for proper toggle restoration
            plantDrugTypeIDs: plant?.drugTypeIDList?.map(item => Number(item.drugTypeID || item)) || [],
            plantSupplyTypeIDs: plant?.supplyTypeIDList?.map(item => Number(item.supplyTypeID || item)) || [],
            plantPlantTypeIDs: plant?.plantTypeIDList?.map(item => Number(item.plantTypeID || item)) || [],
            plantFacilityTypeIDs: plant?.facilityTypeIDList?.map(item => Number(item.facilityTypeID || item)) || [],
            configurations: plant?.configurations || null,  // null means "not initialized yet, will default to all ON"
            // Freight forwarder — map from API response so eye/edit shows the saved FF.
            freightForwarder: (() => {
              const ffd = plant?.freightForwardersDetails || plant?.freightForwarderDetails || {};
              return {
                id: ffd.freightForwarderID || '',
                name: ffd.freightForwarderName || '',
                portal: ffd.portal || '',
                billingCenter: ffd.billingCentreForShipment || ffd.billingCenterForShipment || '',
                collabrixFreightForwarderID:
                  ffd.collabribrixFreightForwarderID || ffd.collabrixFreightForwarderID || null,
              };
            })()
          });
        });
      });
      
     
      const shouldReload = !plantsInitialized;
      
      if (allPlants.length > 0 && shouldReload) {
        setManufacturingPlants(allPlants);
        setPlantsInitialized(true);
        
        // Sync current plant's addresses and configs
        const currentPlant = allPlants[manufacturingPlantTabIndex] || allPlants[0];
        if (currentPlant) {
          setStepData(prev => ({
            ...prev,
            mainAddress: currentPlant.mainAddress || prev.mainAddress,
            pickupAddress: currentPlant.pickupAddress || prev.pickupAddress,
            deliveryAddress: currentPlant.deliveryAddress || prev.deliveryAddress
          }));
          if (currentPlant.configurations) {
            setSelectedConfigs(currentPlant.configurations);
          }
        }
      }
    }
  }, [formData, dataSource, manufacturingPlantTabIndex, plantsInitialized, readOnly]);

 
  useEffect(() => {
    // Check if we're navigating back (activeStep decreased)
    if (prevActiveStepRef.current !== undefined && prevActiveStepRef.current !== activeStep) {
      // Reset the flag to allow reinitialization when navigating
      setPlantsInitialized(false);
    }
    prevActiveStepRef.current = activeStep;
  }, [activeStep]);

  // Enable all tabs when user navigated back from next stepper (parent passes this prop)
  useEffect(() => {
    if (navigatedBackToPlantDetails && manufacturingPlants.length > 0) {
      setUnlockedTabs(Array(manufacturingPlants.length).fill(true));
      onNavigatedBackHandled?.();
    }
  }, [navigatedBackToPlantDetails, manufacturingPlants.length, onNavigatedBackHandled]);

  // Initialize unlockedTabs when manufacturingPlants changes (length changes)
  useEffect(() => {
    if (manufacturingPlants.length > 0 && !navigatedBackToPlantDetails) {
      setUnlockedTabs(prev => {
        // Only initialize if the array length doesn't match
        if (prev.length !== manufacturingPlants.length) {
          // In readOnly mode, all tabs are unlocked. Otherwise, only first tab is unlocked
          return readOnly 
            ? Array(manufacturingPlants.length).fill(true)
            : [true, ...Array(manufacturingPlants.length - 1).fill(false)];
        }
        return prev;
      });
    }
  }, [manufacturingPlants.length, readOnly, navigatedBackToPlantDetails]);

  useEffect(() => {
    // Validate postal codes when country changes
    ['mainAddress', 'pickupAddress', 'deliveryAddress'].forEach(addressType => {
      const address = stepData[addressType] || {};
      if (address.country && address.zipCode) {
        // Convert country name to isoCode
        const countryIsoCode = Country.getAllCountries().find(
          (c) => c.name === address.country
        )?.isoCode;
        if (countryIsoCode) {
          const result = postalCodes.validate(countryIsoCode, String(address.zipCode));
          setPostalCodeErrors(prev => ({
            ...prev,
            [addressType]: result === true ? '' : result
          }));
        } else {
          setPostalCodeErrors(prev => ({
            ...prev,
            [addressType]: 'Invalid country selected'
          }));
        }
      }
    });
  }, [
    stepData.mainAddress?.country,
    stepData.pickupAddress?.country,
    stepData.deliveryAddress?.country,
    stepData.mainAddress?.zipCode,
    stepData.pickupAddress?.zipCode,
    stepData.deliveryAddress?.zipCode
  ]);

  useEffect(() => {
    const fetchConfigData = async () => {
      setTabsLoading(true);
      try {
        // Fetch Facility Types
        const facilityTypesRes = await axios.get(`${API_BASE_URL}/fetchFacilityTypes/true`);
        const allFacilityTypes = facilityTypesRes?.data?.data?.facilityTypesList || [];
        // In both read-only and edit mode: show ALL types (toggled on AND off) so review stepper displays complete configuration
        setFacilityTypes(allFacilityTypes);

        // Fetch Supply Types
        const supplyTypesRes = await axios.get(`${API_BASE_URL}/fetchPlantSupplyTypes/true`);
        const allSupplyTypes = supplyTypesRes?.data?.data?.supplyTypeList || [];
        // In both read-only and edit mode: show ALL types (toggled on AND off) so review stepper displays complete configuration
        setSupplyTypes(allSupplyTypes);

        // Fetch Drug Types - filter based on mode
        const drugTypesRes = await axios.get(`${API_BASE_URL}/fetchPlantDrugTypes/true`);
        const allDrugTypes = drugTypesRes?.data?.data?.drugTypeList || [];
        // In both read-only and edit mode: show ALL types (toggled on AND off) so review stepper displays complete configuration
        setDrugTypes(allDrugTypes);

        // Fetch Plant Types
        const plantTypesRes = await axios.get(`${API_BASE_URL}/fetchPlantTypes/true`);
        const allPlantTypes = plantTypesRes?.data?.data?.plantTypeList || [];
        // In both read-only and edit mode: show ALL types (toggled on AND off) so review stepper displays complete configuration
        setPlantTypes(allPlantTypes);

      } catch (error) {
        console.error('Error fetching configuration data:', error);
        setError('Failed to fetch configuration data');
      } finally {
        setTabsLoading(false);
      }
    };

    fetchConfigData();
  }, [readOnly, API_BASE_URL]);

  // Initialize selected configs when data is loaded
  useEffect(() => {
    if (configsInitialized) {
      return;
    }
    
    if (drugTypes.length > 0 && supplyTypes.length > 0 && plantTypes.length > 0 && facilityTypes.length > 0) {

      // Prioritize dataSource data over formData
      let drugTypeIDList = [];
      let supplyTypeIDList = [];
      let plantTypeIDList = [];
      let facilityTypeIDList = [];

      // In read-only mode (view mode), ONLY use dataSource (API response)
      // In edit mode, prefer formData (for back navigation), then fallback to dataSource
      if (readOnly) {
        // View mode - use API response only
        if (dataSource && Object.keys(dataSource).length > 0) {
          if (dataSource.drugTypeIDs && Array.isArray(dataSource.drugTypeIDs)) {
            drugTypeIDList = dataSource.drugTypeIDs.map(item => Number(item.drugTypeID || item));
          } else if (dataSource.drugTypeIDList && Array.isArray(dataSource.drugTypeIDList)) {
            drugTypeIDList = dataSource.drugTypeIDList.map(item => Number(item.drugTypeID || item));
          }

          if (dataSource.supplyTypeIDs && Array.isArray(dataSource.supplyTypeIDs)) {
            supplyTypeIDList = dataSource.supplyTypeIDs.map(item => Number(item.supplyTypeID || item));
          } else if (dataSource.supplyTypeIDList && Array.isArray(dataSource.supplyTypeIDList)) {
            supplyTypeIDList = dataSource.supplyTypeIDList.map(item => Number(item.supplyTypeID || item));
          }

          if (dataSource.plantTypeIDs && Array.isArray(dataSource.plantTypeIDs)) {
            plantTypeIDList = dataSource.plantTypeIDs.map(item => Number(item.plantTypeID || item));
          } else if (dataSource.plantTypeIDList && Array.isArray(dataSource.plantTypeIDList)) {
            plantTypeIDList = dataSource.plantTypeIDList.map(item => Number(item.plantTypeID || item));
          }

          if (dataSource.facilityTypeIDs && Array.isArray(dataSource.facilityTypeIDs)) {
            facilityTypeIDList = dataSource.facilityTypeIDs.map(item => Number(item.facilityTypeID || item));
          } else if (dataSource.facilityTypeIDList && Array.isArray(dataSource.facilityTypeIDList)) {
            facilityTypeIDList = dataSource.facilityTypeIDList.map(item => Number(item.facilityTypeID || item));
          }
        }
      } else {
        // Edit mode - prefer formData (for back navigation), fallback to dataSource
        if (formData && Object.keys(formData).length > 0 && formData.drugTypeIDList) {
          drugTypeIDList = formData.drugTypeIDList?.map(item => Number(item.drugTypeID || item)) || [];
          supplyTypeIDList = formData.supplyTypeIDList?.map(item => Number(item.supplyTypeID || item)) || [];
          plantTypeIDList = formData.plantTypeIDList?.map(item => Number(item.plantTypeID || item)) || [];
          facilityTypeIDList = formData.facilityTypeIDList?.map(item => Number(item.facilityTypeID || item)) || [];
        } else if (dataSource && Object.keys(dataSource).length > 0) {
          if (dataSource.drugTypeIDs && Array.isArray(dataSource.drugTypeIDs)) {
            drugTypeIDList = dataSource.drugTypeIDs.map(item => Number(item.drugTypeID || item));
          } else if (dataSource.drugTypeIDList && Array.isArray(dataSource.drugTypeIDList)) {
            drugTypeIDList = dataSource.drugTypeIDList.map(item => Number(item.drugTypeID || item));
          }

          if (dataSource.supplyTypeIDs && Array.isArray(dataSource.supplyTypeIDs)) {
            supplyTypeIDList = dataSource.supplyTypeIDs.map(item => Number(item.supplyTypeID || item));
          } else if (dataSource.supplyTypeIDList && Array.isArray(dataSource.supplyTypeIDList)) {
            supplyTypeIDList = dataSource.supplyTypeIDList.map(item => Number(item.supplyTypeID || item));
          }

          if (dataSource.plantTypeIDs && Array.isArray(dataSource.plantTypeIDs)) {
            plantTypeIDList = dataSource.plantTypeIDs.map(item => Number(item.plantTypeID || item));
          } else if (dataSource.plantTypeIDList && Array.isArray(dataSource.plantTypeIDList)) {
            plantTypeIDList = dataSource.plantTypeIDList.map(item => Number(item.plantTypeID || item));
          }

          if (dataSource.facilityTypeIDs && Array.isArray(dataSource.facilityTypeIDs)) {
            facilityTypeIDList = dataSource.facilityTypeIDs.map(item => Number(item.facilityTypeID || item));
          } else if (dataSource.facilityTypeIDList && Array.isArray(dataSource.facilityTypeIDList)) {
            facilityTypeIDList = dataSource.facilityTypeIDList.map(item => Number(item.facilityTypeID || item));
          }
        }
      }


      // Initialize selection arrays
      let productModalitySelections = [];
      let manufacturingSupplyTypeSelections = [];
      let plantTypeSelections = [];
      let manufacturingPlantTypeSelections = [];

      // Initialize based on extracted IDs
      if (drugTypes.length > 0) {
        if (drugTypeIDList.length > 0) {
          productModalitySelections = drugTypes.map(type => {
            const isSelected = drugTypeIDList.includes(Number(type.drugTypeID));
            return isSelected;
          });
        } else {
          // In read-only mode, if no IDs from API, set all to false
          // In edit mode, use activated status
          productModalitySelections = drugTypes.map(type => readOnly ? false : type.activated === true);
        }
      }

      if (supplyTypes.length > 0) {
        if (supplyTypeIDList.length > 0) {
          manufacturingSupplyTypeSelections = supplyTypes.map(type => {
            const isSelected = supplyTypeIDList.includes(Number(type.supplyTypeID));
            return isSelected;
          });
        } else {
          manufacturingSupplyTypeSelections = supplyTypes.map(type => readOnly ? false : type.activated === true);
        }
      }

      if (plantTypes.length > 0) {
        if (plantTypeIDList.length > 0) {
          plantTypeSelections = plantTypes.map(type => {
            const isSelected = plantTypeIDList.includes(Number(type.plantTypeID));
            return isSelected;
          });
        } else {
          plantTypeSelections = plantTypes.map(type => readOnly ? false : type.activated === true);
        }
      }

      if (facilityTypes.length > 0) {
        if (facilityTypeIDList.length > 0) {
          manufacturingPlantTypeSelections = facilityTypes.map(type => {
            const isSelected = facilityTypeIDList.includes(Number(type.facilityTypeID));
            return isSelected;
          });
        } else {
          manufacturingPlantTypeSelections = facilityTypes.map(type => readOnly ? false : type.activated === true);
        }
      }

      const finalSelectedConfigs = {
        productModality: productModalitySelections,
        manufacturingSupplyType: manufacturingSupplyTypeSelections,
        plantType: plantTypeSelections,
        manufacturingPlantType: manufacturingPlantTypeSelections,
      };

      setSelectedConfigs(finalSelectedConfigs);
      
      // Initialize configurations for all plants that don't have them yet (null or missing)
      // Use plant-specific ID lists if available, otherwise use vendor-level or activated defaults
      setManufacturingPlants(prevPlants => {
        return prevPlants.map(plant => {
          if (!plant.configurations) {
            // In read-only mode, ALWAYS check if plant has ID lists (even if empty)
            // In edit mode, check if plant has ID lists with data
            const hasPlantSpecificData = readOnly
              ? (plant.plantDrugTypeIDs !== undefined || 
                 plant.plantSupplyTypeIDs !== undefined || 
                 plant.plantPlantTypeIDs !== undefined || 
                 plant.plantFacilityTypeIDs !== undefined)
              : ((plant.plantDrugTypeIDs && plant.plantDrugTypeIDs.length > 0) ||
                 (plant.plantSupplyTypeIDs && plant.plantSupplyTypeIDs.length > 0) ||
                 (plant.plantPlantTypeIDs && plant.plantPlantTypeIDs.length > 0) ||
                 (plant.plantFacilityTypeIDs && plant.plantFacilityTypeIDs.length > 0));

            if (hasPlantSpecificData) {
              // Use plant-specific ID lists to initialize configurations
              const plantConfigs = {
                productModality: drugTypes.map(type => 
                  plant.plantDrugTypeIDs?.includes(Number(type.drugTypeID)) || false
                ),
                manufacturingSupplyType: supplyTypes.map(type => 
                  plant.plantSupplyTypeIDs?.includes(Number(type.supplyTypeID)) || false
                ),
                plantType: plantTypes.map(type => 
                  plant.plantPlantTypeIDs?.includes(Number(type.plantTypeID)) || false
                ),
                manufacturingPlantType: facilityTypes.map(type => 
                  plant.plantFacilityTypeIDs?.includes(Number(type.facilityTypeID)) || false
                ),
              };
              
              return {
                ...plant,
                configurations: plantConfigs
              };
            } else {
              // Use vendor-level selections or activated defaults for new plants (only in edit mode)
              return {
                ...plant,
                configurations: {
                  productModality: productModalitySelections,
                  manufacturingSupplyType: manufacturingSupplyTypeSelections,
                  plantType: plantTypeSelections,
                  manufacturingPlantType: manufacturingPlantTypeSelections,
                }
              };
            }
          }
          return plant;
        });
      });
      
      setConfigsInitialized(true); // Mark as initialized
    }
  }, [drugTypes, supplyTypes, plantTypes, facilityTypes, dataSource, configsInitialized, readOnly]);

  // Sync selectedConfigs with current plant's configurations when tab changes
  // If plant doesn't have configurations initialized, initialize them based on plant's ID lists
  useEffect(() => {
    const currentPlant = getCurrentPlant();
    if (currentPlant) {
      if (currentPlant.configurations) {
        // Plant has configurations, use them
        setSelectedConfigs(currentPlant.configurations);
      } else if (drugTypes.length > 0 && supplyTypes.length > 0 && plantTypes.length > 0 && facilityTypes.length > 0) {
        // Plant doesn't have configurations, initialize based on plant's stored ID lists
        const initializedConfigs = {
          productModality: drugTypes.map(type => {
            // In read-only mode, ONLY use plant-specific IDs (even if undefined/empty)
            // In edit mode, check if plant has IDs with data, otherwise use activated status
            if (readOnly) {
              return currentPlant.plantDrugTypeIDs?.includes(Number(type.drugTypeID)) || false;
            } else {
              if (currentPlant.plantDrugTypeIDs && currentPlant.plantDrugTypeIDs.length > 0) {
                return currentPlant.plantDrugTypeIDs.includes(Number(type.drugTypeID));
              }
              return type.activated === true;
            }
          }),
          manufacturingSupplyType: supplyTypes.map(type => {
            if (readOnly) {
              return currentPlant.plantSupplyTypeIDs?.includes(Number(type.supplyTypeID)) || false;
            } else {
              if (currentPlant.plantSupplyTypeIDs && currentPlant.plantSupplyTypeIDs.length > 0) {
                return currentPlant.plantSupplyTypeIDs.includes(Number(type.supplyTypeID));
              }
              return type.activated === true;
            }
          }),
          plantType: plantTypes.map(type => {
            if (readOnly) {
              return currentPlant.plantPlantTypeIDs?.includes(Number(type.plantTypeID)) || false;
            } else {
              if (currentPlant.plantPlantTypeIDs && currentPlant.plantPlantTypeIDs.length > 0) {
                return currentPlant.plantPlantTypeIDs.includes(Number(type.plantTypeID));
              }
              return type.activated === true;
            }
          }),
          manufacturingPlantType: facilityTypes.map(type => {
            if (readOnly) {
              return currentPlant.plantFacilityTypeIDs?.includes(Number(type.facilityTypeID)) || false;
            } else {
              if (currentPlant.plantFacilityTypeIDs && currentPlant.plantFacilityTypeIDs.length > 0) {
                return currentPlant.plantFacilityTypeIDs.includes(Number(type.facilityTypeID));
              }
              return type.activated === true;
            }
          })
        };
        
        // Save initialized configs to the plant
        setManufacturingPlants(prevPlants => {
          const updatedPlants = [...prevPlants];
          if (updatedPlants[manufacturingPlantTabIndex]) {
            updatedPlants[manufacturingPlantTabIndex].configurations = initializedConfigs;
          }
          return updatedPlants;
        });
        
        setSelectedConfigs(initializedConfigs);
      }
    }
  }, [manufacturingPlantTabIndex, manufacturingPlants, drugTypes, supplyTypes, plantTypes, facilityTypes]);

  // Initialize step data from form data
  useEffect(() => {
    // Reinitialize stepData when dataSource or formData changes
    const newStepData = initializeStepData();
    // Use current plant's addresses if available
    const currentPlant = getCurrentPlant();
    if (currentPlant) {
      setStepData({
        ...newStepData,
        mainAddress: currentPlant.mainAddress || newStepData.mainAddress,
        pickupAddress: currentPlant.pickupAddress || newStepData.pickupAddress,
        deliveryAddress: currentPlant.deliveryAddress || newStepData.deliveryAddress
      });
    } else {
      setStepData(newStepData);
    }
  }, [formData, dataSource, manufacturingPlantTabIndex, readOnly]);

  const token = localStorage.getItem('authToken');
  useEffect(() => {

    if (token) {
      try {
        const base64Url = token.split('.')[1]; // Get payload
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
            .join('')
        );

        const payload = JSON.parse(jsonPayload);
        setBrandOwnerMosymphonyID(payload.organization_id)

      } catch (e) {
        console.error('Invalid token', e);
      }
    }
  }, [token]);

  // Removed auto-sync useEffect - addresses should be independent
  // Users can manually enter different addresses for main, pickup, and delivery

  const handleToggle = (tabKey, idx) => {
    const plantIndex = manufacturingPlantTabIndex;
    
    // Update the current plant's configurations
    setManufacturingPlants(prevPlants => {
      const updatedPlants = [...prevPlants];
      if (!updatedPlants[plantIndex]) return prevPlants;
      
      if (!updatedPlants[plantIndex].configurations) {
        updatedPlants[plantIndex].configurations = {
          productModality: [],
          manufacturingSupplyType: [],
          plantType: [],
          manufacturingPlantType: []
        };
      }
      
      const currentConfigs = updatedPlants[plantIndex].configurations[tabKey] || [];
      updatedPlants[plantIndex].configurations[tabKey] = currentConfigs.map((val, i) => (i === idx ? !val : val));
      
      return updatedPlants;
    });
    
    
    setSelectedConfigs((prev) => {
      const newConfig = {
        ...prev,
        [tabKey]: prev[tabKey].map((val, i) => (i === idx ? !val : val)),
      };



      // Create arrays of selected IDs
      const updatedData = {};

      if (tabKey === 'productModality' && drugTypes.length > 0) {
        const drugTypeIDList = [];
        newConfig.productModality.forEach((selected, i) => {
          if (selected && drugTypes[i]) {
            drugTypeIDList.push(drugTypes[i].drugTypeID);
          }
        });
        updatedData.drugTypeIDList = drugTypeIDList;



        // Call onFieldChange for this specific field if it exists
        if (typeof onFieldChange === 'function') {
          onFieldChange('drugTypeIDList', drugTypeIDList);
        }
      }

      if (tabKey === 'manufacturingSupplyType' && supplyTypes.length > 0) {
        const supplyTypeIDList = [];
        newConfig.manufacturingSupplyType.forEach((selected, i) => {
          if (selected && supplyTypes[i]) {
            supplyTypeIDList.push(supplyTypes[i].supplyTypeID);
          }
        });
        updatedData.supplyTypeIDList = supplyTypeIDList;



        // Call onFieldChange for this specific field if it exists
        if (typeof onFieldChange === 'function') {
          onFieldChange('supplyTypeIDList', supplyTypeIDList);
        }
      }

      if (tabKey === 'plantType' && plantTypes.length > 0) {
        const plantTypeIDList = [];
        newConfig.plantType.forEach((selected, i) => {
          if (selected && plantTypes[i]) {
            plantTypeIDList.push(plantTypes[i].plantTypeID);
          }
        });
        updatedData.plantTypeIDList = plantTypeIDList;



        // Call onFieldChange for this specific field if it exists
        if (typeof onFieldChange === 'function') {
          onFieldChange('plantTypeIDList', plantTypeIDList);
        }
      }

      if (tabKey === 'manufacturingPlantType' && facilityTypes.length > 0) {
        const facilityTypeIDList = [];
        newConfig.manufacturingPlantType.forEach((selected, i) => {
          if (selected && facilityTypes[i]) {
            facilityTypeIDList.push(facilityTypes[i].facilityTypeID);
          }
        });
        updatedData.facilityTypeIDList = facilityTypeIDList;



        // Call onFieldChange for this specific field if it exists
        if (typeof onFieldChange === 'function') {
          onFieldChange('facilityTypeIDList', facilityTypeIDList);
        }
      }

      // Update parent component if updateStepData exists
      if (typeof updateStepData === 'function') {

        // Create a merged object with the current stepData and the updated data
        const updatedStepData = {
          ...stepData,
          ...updatedData
        };

        // Update the local state first
        setStepData(updatedStepData);

        // Then update the parent component
        updateStepData(updatedStepData);
      }

      return newConfig;
    });
  };
  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setStepData(prev => ({ ...prev, [name]: value }));

    // Call parent's onFieldChange function if it exists
    if (typeof onFieldChange === 'function') {
      onFieldChange(name, value);
    }

    // Clear validation errors when a field is changed
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  // Update handlers to use API field names
  // const handlePlantCodeChange = (e) => {
  //   const value = e.target.value.replace(/[^A-Za-z0-9\-_]/g, '');
  //   setStepData(prev => ({ ...prev, plantCode: value }));

  //   // Call parent's onFieldChange function if it exists
  //   if (typeof onFieldChange === 'function') {
  //     onFieldChange('plantCode', value);
  //   }

  //   if (errors.plantCode) {
  //     setErrors(prev => ({ ...prev, plantCode: '' }));
  //   }
  // };

  // const handlePlantCodeShortNameChange = (e) => {
  //   const value = e.target.value.replace(/[^A-Za-z0-9\-_]/g, '');
  //   setStepData(prev => ({ ...prev, plantCodeShortName: value }));

  //   // Call parent's onFieldChange function if it exists
  //   if (typeof onFieldChange === 'function') {
  //     onFieldChange('plantCodeShortName', value);
  //   }

  //   if (errors.plantCodeShortName) {
  //     setErrors(prev => ({ ...prev, plantCodeShortName: '' }));
  //   }
  // };

  const handleAddressChange = (addressType) => (e) => {
    const value = e.target.value.replace(/[^A-Za-z0-9\s&\.,\-\/()]/g, '');
    setStepData(prev => ({ ...prev, [addressType]: value }));

    // Call parent's onFieldChange function if it exists
    if (typeof onFieldChange === 'function') {
      onFieldChange(addressType, value);
    }

    if (errors[addressType]) {
      setErrors(prev => ({ ...prev, [addressType]: '' }));
    }
  };

  // Update validation to use API field names
    const validationPatterns = {
    // plantCode: /^[A-Za-z0-9\-_]{1,20}$/,
    // plantCodeShortName: /^[A-Za-z0-9\-_]{1,15}$/,
    address: /^[A-Za-zÀ-ÿ0-9\s&\.,\-\/()]{1,255}$/,
    zipCode: /^\d+$/
  };

  const validate = useCallback(() => {
    const newErrors = {};
    let isValid = true;

    // Validate plant code
    // if (!stepData.plantCode?.trim()) {
    //   newErrors.plantCode = "Plant ID From Sponsor ERP is required";
    //   isValid = false;
    // } else if (!validationPatterns.plantCode.test(stepData.plantCode)) {
    //   newErrors.plantCode = "Invalid Plant ID From Sponsor ERP format";
    //   isValid = false;
    // }

    // Validate plant code short name
    // if (!stepData.plantCodeShortName?.trim()) {
    //   newErrors.plantCodeShortName = "Plant ID Short Name is required";
    //   isValid = false;
    // } else if (!validationPatterns.plantCodeShortName.test(stepData.plantCodeShortName)) {
    //   newErrors.plantCodeShortName = "Invalid Plant ID Short Name format";
    //   isValid = false;
    // }

    // Validate addresses for current plant
    const currentPlant = getCurrentPlant();
    const addressesToValidate = currentPlant ? {
      mainAddress: currentPlant.mainAddress || {},
      pickupAddress: currentPlant.pickupAddress || {},
      deliveryAddress: currentPlant.deliveryAddress || {}
    } : {
      mainAddress: stepData.mainAddress || {},
      pickupAddress: stepData.pickupAddress || {},
      deliveryAddress: stepData.deliveryAddress || {}
    };

    ['mainAddress', 'pickupAddress', 'deliveryAddress'].forEach(addressType => {
      const address = addressesToValidate[addressType] || {};

      if (!address?.addressLine1?.trim()) {
        newErrors[`${addressType}.addressLine1`] = "Street Address 1 is required";
        isValid = false;
      } else if (!validationPatterns.address.test(address.addressLine1)) {
        newErrors[`${addressType}.addressLine1`] = "Invalid address format";
        isValid = false;
      }

      if (!address?.addressLine2?.trim()) {
        newErrors[`${addressType}.addressLine2`] = "Street Address 2 is required";
        isValid = false;
      } else if (!validationPatterns.address.test(address.addressLine2)) {
        newErrors[`${addressType}.addressLine2`] = "Invalid address format";
        isValid = false;
      }

      if (!address?.country?.trim()) {
        newErrors[`${addressType}.country`] = "Country is required";
        isValid = false;
      }

      if (!address?.state?.trim()) {
        newErrors[`${addressType}.state`] = "State is required";
        isValid = false;
      }

      if (!address?.city?.trim()) {
        newErrors[`${addressType}.city`] = "City is required";
        isValid = false;
      }

      // Post Code validation
      if (address.zipCode && String(address.zipCode).trim()) {
        // Convert country name to isoCode for validation
        const countryName = address.country;
        const countryIsoCode = Country.getAllCountries().find(
          (c) => c.name === countryName
        )?.isoCode;

        if (countryIsoCode) {
          const result = postalCodes.validate(countryIsoCode, String(address.zipCode));
          if (result !== true) {
            newErrors[`${addressType}.zipCode`] = 'Invalid postal code format for this country';
            isValid = false;
          }
        }
      } else if (!address.zipCode || !String(address.zipCode).trim()) {
        newErrors[`${addressType}.zipCode`] = "Post Code is required";
        isValid = false;
      }
    });

    // Validate unique Line/Suite IDs within each manufacturing plant
    if (manufacturingPlants && manufacturingPlants.length > 0) {
      manufacturingPlants.forEach((plant, plantIndex) => {
        if (plant.lineSuites && Array.isArray(plant.lineSuites)) {
          const lineSuiteIDs = plant.lineSuites
            .map(ls => ls.lineSuiteID?.trim())
            .filter(id => id !== ''); // Only check non-empty IDs
          
          // Check for duplicates
          const seen = new Set();
          lineSuiteIDs.forEach((id, index) => {
            const lowerId = id.toLowerCase();
            if (seen.has(lowerId)) {
              // Find all indices with this duplicate ID
              const duplicateIndices = [];
              plant.lineSuites.forEach((ls, idx) => {
                if (ls.lineSuiteID?.trim().toLowerCase() === lowerId) {
                  duplicateIndices.push(idx);
                }
              });
              // Set error for all duplicates
              duplicateIndices.forEach(dupIdx => {
                newErrors[`manufacturingPlant_${plantIndex}_lineSuite_${dupIdx}_lineSuiteID`] = 'Line/Suite ID must be unique';
              });
              isValid = false;
            } else {
              seen.add(lowerId);
            }
          });
        }
      });
    }

    setErrors(newErrors);
    return isValid;
  }, [stepData, postalCodeErrors, manufacturingPlants, manufacturingPlantTabIndex]);

  const handlePostalCodeChange = (addressType) => (e) => {
    const value = e.target.value;
    const plantIndex = manufacturingPlantTabIndex;

    // Update the current plant's address
    setManufacturingPlants(prevPlants => {
      const updatedPlants = [...prevPlants];
      if (!updatedPlants[plantIndex]) return prevPlants;
      
      if (!updatedPlants[plantIndex][addressType]) {
        updatedPlants[plantIndex][addressType] = {
          addressLine1: '',
          addressLine2: '',
          country: '',
          state: '',
          city: '',
          zipCode: ''
        };
      }
      
      updatedPlants[plantIndex][addressType] = {
        ...updatedPlants[plantIndex][addressType],
        zipCode: value
      };
      
      return updatedPlants;
    });

    setStepData(prev => {
      // Update only the specific address - addresses are independent
      return {
        ...prev,
        [addressType]: {
          ...prev[addressType],
          zipCode: value
        }
      };
    });

    // Call parent's onFieldChange if it exists
    if (typeof onFieldChange === 'function') {
      onFieldChange(`${addressType}.zipCode`, value);
    }

    // Clear any existing errors
    setPostalCodeErrors(prev => ({ ...prev, [addressType]: '' }));
    setErrors(prev => ({ ...prev, [`${addressType}.zipCode`]: '' }));

    // If field is empty, we're done - no validation needed
    if (!value || !value.trim()) {
      return;
    }
    // Convert country name to isoCode for validation
    const countryName = stepData[addressType]?.country;
    const countryIsoCode = Country.getAllCountries().find(
      (c) => c.name === countryName
    )?.isoCode;

    if (countryIsoCode) {
      const result = postalCodes.validate(countryIsoCode, value);
      const errorMsg = result === true ? '' : 'Invalid postal code format for this country';
      setPostalCodeErrors(prev => ({ ...prev, [addressType]: errorMsg }));
    }
  };


  const handleNextClick = async () => {
    setSubmitted(true);

    // Validate current tab data
    if (!validate()) {
      return;
    }

    // Check if we're on the last manufacturing plant tab
    const isLastPlantTab = manufacturingPlantTabIndex === manufacturingPlants.length - 1;

    // If not the last tab, just move to next tab without calling API
    if (!isLastPlantTab) {
      // Save current tab data to state
      updateStepData({
        ...stepData,
        manufacturingPlants: manufacturingPlants
      });
      
      // Move to next tab
      const nextTabIndex = manufacturingPlantTabIndex + 1;
      
      // Unlock the next tab
      setUnlockedTabs(prev => {
        const updated = [...prev];
        if (nextTabIndex < updated.length) {
          updated[nextTabIndex] = true;
        }
        return updated;
      });
      
      setManufacturingPlantTabIndex(nextTabIndex);
      // Reset configuration sub-tabs to first tab when moving to next manufacturing plant
      setTabIndex(0);
      
      // Scroll to top of section for better UX
      if (plantDetailsSectionRef.current) {
        plantDetailsSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      
      // Update tabsVisited
      setTabsVisited(prev => {
        const updated = [...prev];
        updated[nextTabIndex] = true;
        return updated;
      });
      
      // Reset submitted state for the new tab
      setSubmitted(false);
      
      // Sync addresses and configs for the new tab
      const nextPlant = manufacturingPlants[nextTabIndex];
      if (nextPlant) {
        setStepData(prev => ({
          ...prev,
          mainAddress: nextPlant.mainAddress || prev.mainAddress,
          pickupAddress: nextPlant.pickupAddress || prev.pickupAddress,
          deliveryAddress: nextPlant.deliveryAddress || prev.deliveryAddress
        }));
        if (nextPlant.configurations) {
          setSelectedConfigs(nextPlant.configurations);
        }
      }
      
      return; // Exit early, don't call API
    }

    // Only call API when on the last tab
    setLoading(true);
    setError("");

    try {
      // Get cmoSites from formData (saved by SiteDetails step)
      const sourceData = (Object.keys(dataSource).length > 0) ? dataSource : formData;
      const existingCmoSites = sourceData?.cmoSites || [];
      
      // Helper function to convert configuration boolean array to ID list (only IDs as array)
      const getConfigIDList = (configArray, typeArray, idField) => {
        const idList = [];
        if (configArray && Array.isArray(configArray) && typeArray && Array.isArray(typeArray)) {
          configArray.forEach((selected, idx) => {
            if (selected && typeArray[idx]) {
              idList.push(Number(typeArray[idx][idField]));
            }
          });
        }
        return idList;
      };

      // Helper function to build plant data for API
      const buildPlantData = (plant, originalPlant, site) => {
        // Get configurations for this plant
        const plantConfigs = plant.configurations || {};
        
        // Convert lineSuites to lineDetailsList format
        // Filter out empty entries and duplicates, trim values
        const seenLineIDs = new Set();
        const lineDetailsList = (plant.lineSuites || [])
          .map(lineSuite => ({
            lineID: (lineSuite.lineSuiteID || '').trim(),
            lineShortName: (lineSuite.lineSuiteShortName || '').trim()
          }))
          .filter(line => {
            // Filter out empty line IDs
            if (!line.lineID) return false;
            // Filter out duplicates (case-insensitive)
            const lowerId = line.lineID.toLowerCase();
            if (seenLineIDs.has(lowerId)) return false;
            seenLineIDs.add(lowerId);
            return true;
          });

        // Get configuration ID lists (only IDs, no names)
        const plantTypeIDList = getConfigIDList(
          plantConfigs.plantType,
          plantTypes,
          'plantTypeID'
        );
        const drugTypeIDList = getConfigIDList(
          plantConfigs.productModality,
          drugTypes,
          'drugTypeID'
        );
        const supplyTypeIDList = getConfigIDList(
          plantConfigs.manufacturingSupplyType,
          supplyTypes,
          'supplyTypeID'
        );
        const facilityTypeIDList = getConfigIDList(
          plantConfigs.manufacturingPlantType,
          facilityTypes,
          'facilityTypeID'
        );

        // Build mfgPlantDetails - always include collabrix IDs (following SiteDetails pattern)
        // Check multiple sources: plant object, originalPlant, and site
        const collabrixMfgPlantID = plant?.collabrixMfgPlantID || originalPlant?.collabrixMfgPlantID || originalPlant?.mfgPlantDetails?.collabrixMfgPlantID;
        const collabrixCMOSiteID = plant?.collabrixCMOSiteID || site?.collabrixCMOSiteID || site?.siteDetails?.collabrixCMOSiteID;
        
        const mfgPlantDetails = {
          collabrixCMOSiteID: collabrixCMOSiteID,
          collabrixMfgPlantID: collabrixMfgPlantID,
          mfgPlantID: plant.manufacturingPlantID || '',
          mfgPlantShortName: plant.manufacturingPlantShortName || '',
          aslNumber: plant.aslNumber || '', // TODO: Get from plant data if available
          markForDelete: false
        };

        // BCM-3PL: Freight Forwarder Details for this plant (one FF per MFG plant).
        // Rides inside each plant's data so it persists through the SAME
        // /updateVendorPlantDetails call as the rest of the plant config — no
        // separate API. Only included when the user actually entered FF data, so
        // plants without a freight forwarder don't send an empty record.
        // Key/fields match the /updateVendorPlantDetails spec (freightForwardersDetails).
        // UI captures: id (business FF id, e.g. 1758), name, portal (tracking URL),
        //   billingCenter (Billing Centre for Shipment).
        const ff = plant.freightForwarder || {};
        const ffHasData = [ff.id, ff.name, ff.portal, ff.billingCenter]
          .some((v) => v !== undefined && v !== null && String(v).trim() !== '');
        const freightForwardersDetails = ffHasData
          ? {
              collabrixMFGPlantID: collabrixMfgPlantID,
              ...(ff.collabrixFreightForwarderID
                ? { collabrixFreightForwarderID: ff.collabrixFreightForwarderID }
                : {}),
              freightForwarderID: (ff.id ?? '').toString().trim(),
              freightForwarderName: (ff.name ?? '').toString().trim(),
              portal: (ff.portal ?? '').toString().trim(),
              billingCentreForShipment: (ff.billingCenter ?? '').toString().trim(),
              markForDelete: false,
            }
          : null;

        return {
          mfgPlantDetails,
          lineDetailsList: lineDetailsList,
          // Included only when FF data is present (see above).
          ...(freightForwardersDetails ? { freightForwardersDetails } : {}),
          mainAddress: {
            addressLine1: plant.mainAddress?.addressLine1 || '',
            addressLine2: plant.mainAddress?.addressLine2 || '',
            city: plant.mainAddress?.city || '',
            state: plant.mainAddress?.state || '',
            country: plant.mainAddress?.country || '',
            zipCode: plant.mainAddress?.zipCode || ''
          },
          pickupAddress: {
            addressLine1: plant.pickupAddress?.addressLine1 || '',
            addressLine2: plant.pickupAddress?.addressLine2 || '',
            city: plant.pickupAddress?.city || '',
            state: plant.pickupAddress?.state || '',
            country: plant.pickupAddress?.country || '',
            zipCode: plant.pickupAddress?.zipCode || ''
          },
          deliveryAddress: {
            addressLine1: plant.deliveryAddress?.addressLine1 || '',
            addressLine2: plant.deliveryAddress?.addressLine2 || '',
            city: plant.deliveryAddress?.city || '',
            state: plant.deliveryAddress?.state || '',
            country: plant.deliveryAddress?.country || '',
            zipCode: plant.deliveryAddress?.zipCode || ''
          },
          plantTypeIDList: plantTypeIDList,
          drugTypeIDList: drugTypeIDList,
          supplyTypeIDList: supplyTypeIDList,
          facilityTypeIDList: facilityTypeIDList
        };
      };

      // Build cmoSites array - use existingCmoSites if available, otherwise build from manufacturingPlants
      let cmoSites = [];
      
      if (existingCmoSites.length > 0) {
        // Use existing cmoSites structure and update with manufacturingPlants data
        cmoSites = existingCmoSites.map((site) => {
          // Find all manufacturing plants for this site from our manufacturingPlants array
          const siteID = site?.siteDetails?.siteID || site?.siteID || '';
          const sitePlants = manufacturingPlants.filter(
            plant => plant.siteID === siteID
          );

          // Build manufacturingPlantDataList for this site
          const manufacturingPlantDataList = sitePlants.map((plant) => {
            // Get original plant data to preserve collabrix IDs
            const originalSitePlants = site?.siteManufacturingPlants || site?.manufacturingPlantDataList || [];
            const originalPlant = originalSitePlants.find(
              p => p.mfgPlantID === plant.manufacturingPlantID || p.mfgPlantDetails?.mfgPlantID === plant.manufacturingPlantID
            );

            return buildPlantData(plant, originalPlant, site);
          });

          // Build siteDetails - always include collabrixCMOSiteID (following SiteDetails pattern)
          const collabrixCMOSiteID = site?.siteDetails?.collabrixCMOSiteID || site?.collabrixCMOSiteID;
          const siteDetails = {
            collabrixCMOSiteID: collabrixCMOSiteID,
            siteID: site?.siteDetails?.siteID || site?.siteID || '',
            siteShortName: site?.siteDetails?.siteShortName || site?.siteShortName || '',
            markForDelete: false
          };

          return {
            siteDetails,
            manufacturingPlantDataList: manufacturingPlantDataList
          };
        });
      } else if (manufacturingPlants.length > 0) {
        // Build cmoSites from manufacturingPlants when existingCmoSites is empty
        // Group plants by siteID
        const sitesMap = new Map();
        
        manufacturingPlants.forEach((plant) => {
          const siteID = plant.siteID || '';
          const siteShortName = plant.siteShortName || '';
          const collabrixCMOSiteID = plant.collabrixCMOSiteID;
          
          if (!sitesMap.has(siteID)) {
            sitesMap.set(siteID, {
              siteID: siteID,
              siteShortName: siteShortName,
              collabrixCMOSiteID: collabrixCMOSiteID,
              plants: []
            });
          }
          
          sitesMap.get(siteID).plants.push(plant);
        });

        // Convert map to cmoSites array
        cmoSites = Array.from(sitesMap.values()).map((siteGroup) => {
          const manufacturingPlantDataList = siteGroup.plants.map((plant) => {
            return buildPlantData(plant, null, { 
              siteID: siteGroup.siteID, 
              siteShortName: siteGroup.siteShortName,
              collabrixCMOSiteID: siteGroup.collabrixCMOSiteID
            });
          });

          // Include collabrixCMOSiteID from the site group (may be undefined for new sites)
          return {
            siteDetails: {
              collabrixCMOSiteID: siteGroup.collabrixCMOSiteID,
              siteID: siteGroup.siteID,
              siteShortName: siteGroup.siteShortName,
              markForDelete: false
            },
            manufacturingPlantDataList: manufacturingPlantDataList
          };
        });
      }

      // Build the payload according to API structure
      // Get vendor plant details from the data source for top-level fields
      const vendorPlantDetailsSource = originalVendorPlantDetails?.vendorPlantDetails?.vendorPlantDetails || 
                                       selectedCMOFormData?.vendorPlantDetails || 
                                       formData?.vendorPlantDetails || 
                                       formData || {};
      
      const payload = {
        vendorMosymphonyID: cmoDetailsResponse?.organizationId,
        brandOwnerMosymphonyID: brandOwnerMosymphonyID,
        vendorPlantDetails: {
          vendorMosymphonyID: cmoDetailsResponse?.organizationId,
          cmoHasMultipleSites: formData?.cmoHasMultipleSites === "Yes" || formData?.cmoHasMultipleSites === true,
          deliveryAddress: {
            addressLine1: vendorPlantDetailsSource?.deliveryAddress?.addressLine1 || '',
            addressLine2: vendorPlantDetailsSource?.deliveryAddress?.addressLine2 || '',
            city: vendorPlantDetailsSource?.deliveryAddress?.city || '',
            state: vendorPlantDetailsSource?.deliveryAddress?.state || '',
            country: vendorPlantDetailsSource?.deliveryAddress?.country || '',
            zipCode: vendorPlantDetailsSource?.deliveryAddress?.zipCode || ''
          },
          pickupAddress: {
            addressLine1: vendorPlantDetailsSource?.pickupAddress?.addressLine1 || '',
            addressLine2: vendorPlantDetailsSource?.pickupAddress?.addressLine2 || '',
            city: vendorPlantDetailsSource?.pickupAddress?.city || '',
            state: vendorPlantDetailsSource?.pickupAddress?.state || '',
            country: vendorPlantDetailsSource?.pickupAddress?.country || '',
            zipCode: vendorPlantDetailsSource?.pickupAddress?.zipCode || ''
          },
          mainAddress: {
            addressLine1: vendorPlantDetailsSource?.mainAddress?.addressLine1 || '',
            addressLine2: vendorPlantDetailsSource?.mainAddress?.addressLine2 || '',
            city: vendorPlantDetailsSource?.mainAddress?.city || '',
            state: vendorPlantDetailsSource?.mainAddress?.state || '',
            country: vendorPlantDetailsSource?.mainAddress?.country || '',
            zipCode: vendorPlantDetailsSource?.mainAddress?.zipCode || ''
          },
          drugTypeIDList: vendorPlantDetailsSource?.drugTypeIDList || [],
          supplyTypeIDList: vendorPlantDetailsSource?.supplyTypeIDList || [],
          plantTypeIDList: vendorPlantDetailsSource?.plantTypeIDList || [],
          facilityTypeIDList: vendorPlantDetailsSource?.facilityTypeIDList || [],
          cmoBatchShipmentSettingID: vendorPlantDetailsSource?.cmoBatchShipmentSettingID || null,
          shipmentDuration: vendorPlantDetailsSource?.shipmentDuration || null,
          automateGRP: vendorPlantDetailsSource?.automateGRP ?? false,
          batchAllocationPDFNotificationReqd: vendorPlantDetailsSource?.batchAllocationPDFNotificationReqd ?? false,
          batchAllocationPDFNotificationSubject: vendorPlantDetailsSource?.batchAllocationPDFNotificationSubject || '',
          batchAllocationPDFNotificationObjective: vendorPlantDetailsSource?.batchAllocationPDFNotificationObjective || '',
          allocationOwnedBySponsor: vendorPlantDetailsSource?.allocationOwnedBySponsor ?? false,
          cmoToUsePOInterface: vendorPlantDetailsSource?.cmoToUsePOInterface ?? false,
          acceptanceLimitForEarlyDeliveryDateChangeByCMO: vendorPlantDetailsSource?.acceptanceLimitForEarlyDeliveryDateChangeByCMO ?? null,
          acceptanceLimitForLaterDeliveryDateChangeByCMO: vendorPlantDetailsSource?.acceptanceLimitForLaterDeliveryDateChangeByCMO ?? null,
          acceptanceLimitForLessDeliveryQuantityChangeByCMO: vendorPlantDetailsSource?.acceptanceLimitForLessDeliveryQuantityChangeByCMO ?? null,
          acceptanceLimitForMoreDeliveryQuantityChangeByCMO: vendorPlantDetailsSource?.acceptanceLimitForMoreDeliveryQuantityChangeByCMO ?? null
        },
        updateCMOSiteDetailsFlag: true,
        updatePlantDetailsFlag: true,
        cmoSites
      };

      // Make the API call
      const response = await axios.post(`${API_BASE_URL}/updateVendorPlantDetails`, payload);

      if (response.data?.status) {
        // Update parent with the complete data including user's changes
        // Use the cmoSites we just sent to the API (includes all user edits)
        updateStepData({
          ...stepData,
          cmoSites: cmoSites, // Use the updated structure with user's changes
          manufacturingPlants: manufacturingPlants
        });
        
        // If this is the last step, call handleSubmit, otherwise call handleNext
        const isLastStep = activeStep !== undefined && stepsLength !== undefined && activeStep === stepsLength - 1;
        if (isLastStep && handleSubmit) {
          handleSubmit();
        } else {
          handleNext();
        }
      } else {
        throw new Error(response.data?.message || "Failed to update manufacturing facility details");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError(err.message || "Failed to update manufacturing facility details");
    } finally {
      setLoading(false);
    }
  };

  // Update address handler to work per-plant
  const createAddressHandler = useCallback((addressType) => (field) => (e) => {
    const value = e.target.value;
    const plantIndex = manufacturingPlantTabIndex;
    
    // Update the current plant's address in manufacturingPlants array
    setManufacturingPlants(prevPlants => {
      const updatedPlants = [...prevPlants];
      if (!updatedPlants[plantIndex]) return prevPlants;
      
      if (!updatedPlants[plantIndex][addressType]) {
        updatedPlants[plantIndex][addressType] = {
          addressLine1: '',
          addressLine2: '',
          country: '',
          state: '',
          city: '',
          zipCode: ''
        };
      }
      
      updatedPlants[plantIndex][addressType] = {
        ...updatedPlants[plantIndex][addressType],
        [field]: value
      };
      
      return updatedPlants;
    });
    
    // Also update stepData for backward compatibility and UI
    setStepData(prev => ({
      ...prev,
      [addressType]: {
        ...prev[addressType],
        [field]: value
      }
    }));
    
    
    if (typeof onFieldChange === 'function') {
      onFieldChange(`${addressType}.${field}`, value);
    }
    
    // Clear errors
    if (errors[`${addressType}.${field}`]) {
      setErrors(prev => ({ ...prev, [`${addressType}.${field}`]: '' }));
    }
  }, [manufacturingPlantTabIndex, onFieldChange, errors]);

  const handleMainAddressChange = createAddressHandler('mainAddress');
  const handlePickupAddressChange = createAddressHandler('pickupAddress');
  const handleDeliveryAddressChange = createAddressHandler('deliveryAddress');


  const handleCountryChange = (addressType) => (e) => {
    const countryCode = e.target.value;
    const countryObj = Country.getCountryByCode(countryCode);
    const plantIndex = manufacturingPlantTabIndex;

    // Update the current plant's address
    setManufacturingPlants(prevPlants => {
      const updatedPlants = [...prevPlants];
      if (!updatedPlants[plantIndex]) return prevPlants;
      
      if (!updatedPlants[plantIndex][addressType]) {
        updatedPlants[plantIndex][addressType] = {
          addressLine1: '',
          addressLine2: '',
          country: '',
          state: '',
          city: '',
          zipCode: ''
        };
      }
      
      updatedPlants[plantIndex][addressType] = {
        ...updatedPlants[plantIndex][addressType],
        country: countryObj?.name || '',
        state: '',
        city: ''
      };
      
      return updatedPlants;
    });

    setStepData(prev => {
      // Update only the specific address - addresses are independent
      return {
        ...prev,
        [addressType]: {
          ...prev[addressType],
          country: countryObj?.name || '',
          countryCode: countryCode,
          state: '',
          stateName: '',
          stateCode: '',
          city: ''
        }
      };
    });

    setPostalCodeErrors(prev => ({ ...prev, [addressType]: '' }));
    setErrors(prev => ({ ...prev, [`${addressType}.zipCode`]: '' }));

    if (onFieldChange) {
      onFieldChange(`${addressType}.country`, countryObj?.name || '');
      onFieldChange(`${addressType}.countryCode`, countryCode);
      onFieldChange(`${addressType}.state`, '');
      onFieldChange(`${addressType}.city`, '');
    }
  };

  const handleStateChange = (addressType) => (e) => {
    const stateCode = e.target.value;
    const plantIndex = manufacturingPlantTabIndex;
    const currentPlant = getCurrentPlant();
    const countryCode = currentPlant?.[addressType]?.countryCode || stepData[addressType]?.countryCode;
    const stateObj = State.getStateByCodeAndCountry(stateCode, countryCode);

    // Update the current plant's address
    setManufacturingPlants(prevPlants => {
      const updatedPlants = [...prevPlants];
      if (!updatedPlants[plantIndex]) return prevPlants;
      
      if (!updatedPlants[plantIndex][addressType]) {
        updatedPlants[plantIndex][addressType] = {
          addressLine1: '',
          addressLine2: '',
          country: '',
          state: '',
          city: '',
          zipCode: ''
        };
      }
      
      updatedPlants[plantIndex][addressType] = {
        ...updatedPlants[plantIndex][addressType],
        state: stateObj?.name || '',
        city: ''
      };
      
      return updatedPlants;
    });

    setStepData(prev => {
      // Update only the specific address - addresses are independent
      return {
        ...prev,
        [addressType]: {
          ...prev[addressType],
          state: stateObj?.name || '',
          stateCode: stateCode,
          city: ''
        }
      };
    });

    if (onFieldChange) {
      onFieldChange(`${addressType}.state`, stateObj?.name || '');
      onFieldChange(`${addressType}.stateCode`, stateCode);
      onFieldChange(`${addressType}.city`, '');
    }
  };

  const handleCityChange = (addressType) => (e) => {
    const city = e.target.value;
    const plantIndex = manufacturingPlantTabIndex;
    
    // Update the current plant's address
    setManufacturingPlants(prevPlants => {
      const updatedPlants = [...prevPlants];
      if (!updatedPlants[plantIndex]) return prevPlants;
      
      if (!updatedPlants[plantIndex][addressType]) {
        updatedPlants[plantIndex][addressType] = {
          addressLine1: '',
          addressLine2: '',
          country: '',
          state: '',
          city: '',
          zipCode: ''
        };
      }
      
      updatedPlants[plantIndex][addressType] = {
        ...updatedPlants[plantIndex][addressType],
        city
      };
      
      return updatedPlants;
    });
    
    setStepData(prev => {
      // Update only the specific address - addresses are independent
      return {
        ...prev,
        [addressType]: {
          ...prev[addressType],
          city
        }
      };
    });

    if (onFieldChange) {
      onFieldChange(`${addressType}.city`, city);
    }
  };

  const renderTabContent = () => {


    const isTypesLoaded = drugTypes.length > 0 && supplyTypes.length > 0 && plantTypes.length > 0 && facilityTypes.length > 0;
    if (readOnly && !isTypesLoaded) {
      return <div>Loading...</div>;
    }

    if (tabsLoading) {
      return (
        <div className={classes.loaderContainer}>
          <CircularProgress color="primary" />
        </div>
      );
    }

    switch (tabIndex) {
      case 0:
        return (
          <ProductModalityTab
            drugTypes={drugTypes}
            selectedConfigs={selectedConfigs.productModality || []}
            onToggle={(idx) => handleToggle('productModality', idx)}
            readOnly={readOnly}
            isLoading={tabsLoading}
          />
        );
      case 1:
        return (
          <ManufacturingSupplyTypeTab
            supplyTypes={supplyTypes}
            selectedConfigs={selectedConfigs.manufacturingSupplyType || []}
            onToggle={(idx) => handleToggle('manufacturingSupplyType', idx)}
            readOnly={readOnly}
            isLoading={tabsLoading}
          />
        );
      case 2:
        return (
          <PlantTypeTab
            plantTypes={plantTypes}
            selectedConfigs={selectedConfigs.plantType || []}
            onToggle={(idx) => handleToggle('plantType', idx)}
            readOnly={readOnly}
            isLoading={tabsLoading}
          />
        );
      case 3:
        return (
          <ManufacturingPlantTypeTab
            facilityTypes={facilityTypes}
            selectedConfigs={selectedConfigs.manufacturingPlantType || []}
            onToggle={(idx) => handleToggle('manufacturingPlantType', idx)}
            readOnly={readOnly}
            isLoading={tabsLoading}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="cmo-stepper-wrapper plant-details-step" ref={plantDetailsSectionRef}>
      <div className="stepper-container">
        <form>
          {/* <Typography variant="h6" className={classes.formTitle}>
            Plant Details and Configurations
          </Typography> */}
          {/* {error && <Typography color="error" style={{ marginBottom: 16 }}>{error}</Typography>}
          {submitted && Object.keys(errors).length > 0 && (
            <Typography color="error" style={{ marginBottom: 16 }}>
              Please correct the errors below before proceeding.
            </Typography>
          )} */}
          <Grid className="two-col-forms-grid" container spacing={3}>
            {/* Plant Code */}
            {/* <Grid item xs={12} sm={6}>

              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="plantCode">
                  Plant ID From Sponsor ERP {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>                {readOnly ? (
                  <Typography>
                    {formData?.plantCode || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="plantCode"
                    name="plantCode"
                    value={stepData.plantCode || ''}
                    onChange={handlePlantCodeChange}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 20
                    }}
                    onInput={e => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-Z0-9\-_]/g, "")
                        .replace(/(-{2,}|_{2,})/g, (match) => match[0]);
                    }}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.plantCode)}
                    helperText={submitted && errors.plantCode ? errors.plantCode : ''}
                  />
                )}
              </FormControl>
            </Grid> */}
            {/* Plant Code Short Name */}
            {/* <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="plantCodeShortName">
                  Plant ID Short Name {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>                {readOnly ? (
                  <Typography>
                    {formData?.plantCodeShortName || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="plantCodeShortName"
                    name="plantCodeShortName"
                    value={stepData.plantCodeShortName || ''}
                    onChange={handlePlantCodeShortNameChange}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 15
                    }}
                    onInput={e => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-Z0-9\-_]/g, "")
                        .replace(/(-{2,}|_{2,})/g, (match) => match[0]);
                    }}
                    style={commonInlineStyles.input} error={submitted && Boolean(errors.plantCodeShortName)}
                    helperText={submitted && errors.plantCodeShortName ? errors.plantCodeShortName : ''}
                  />
                )}
              </FormControl>
            </Grid> */}
          </Grid>

          {/* BCM-3PL: Section order per spec —
              1) Manufacturing plant names (tabs)
              2) Freight Forwarder Details
              3) Manufacturing Plant Details (Site ID / Line-Suite fields).
              The "Manufacturing Plant Details" heading now sits below the
              Freight Forwarder table (inside the per-tab content), so the tabs
              render first with no heading above them. */}
          {visibleManufacturingPlants && visibleManufacturingPlants.length > 0 ? (
            <>
              <Tabs
                value={getVisibleTabIndex(manufacturingPlantTabIndex) !== -1 ? getVisibleTabIndex(manufacturingPlantTabIndex) : 0}
                onChange={handleManufacturingPlantTabChange}
                indicatorColor="primary"
                textColor="primary"
                style={{ marginBottom: 4 }}
              >
                {visibleManufacturingPlants.map((plant, index) => (
                  <Tab
                    key={plant.originalIndex}
                    label={plant.manufacturingPlantShortName || `Plant ${plant.originalIndex + 1}`}
                    className={classes.tabLabel}
                    disabled={!readOnly && !unlockedTabs[plant.originalIndex] && plant.originalIndex > 0}
                    classes={{ root: classes.tabRoot }}
                  />
                ))}
              </Tabs>

              {manufacturingPlants[manufacturingPlantTabIndex] && (
                <>
                  {/* BCM-3PL: Freight Forwarder Details — one row per Manufacturing Plant.
                      Assumption: a single Freight Forwarder per MFG Plant for now.
                      UI-only; API integration deferred. */}
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 'bold', marginTop: '0px', marginBottom: '12px' }}
                  >
                    Freight Forwarder Details
                  </Typography>
                  <TableContainer
                    component={Paper}
                    style={{
                      marginBottom: 32,
                      boxShadow: 'none',
                      border: '1px solid #e0e0e0',
                    }}
                  >
                    <Table size="small">
                      <TableHead>
                        <TableRow style={{ backgroundColor: '#f5f7fa' }}>
                          <TableCell style={{ fontWeight: 'bold', width: '12%', borderRight: '1px solid #e0e0e0', verticalAlign: 'middle' }}>ID</TableCell>
                          <TableCell style={{ fontWeight: 'bold', width: '23%', borderRight: '1px solid #e0e0e0', verticalAlign: 'middle' }}>Name</TableCell>
                          <TableCell style={{ fontWeight: 'bold', width: '40%', borderRight: '1px solid #e0e0e0', verticalAlign: 'middle' }}>Portal</TableCell>
                          <TableCell style={{ fontWeight: 'bold', width: '25%', verticalAlign: 'middle' }}>Billing Center for Shipment</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={{ borderRight: '1px solid #e0e0e0', verticalAlign: 'middle' }}>
                            {readOnly ? (
                              <Typography>
                                {manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.id || 'N/A'}
                              </Typography>
                            ) : (
                              <TextField
                                value={manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.id || ''}
                                onChange={(e) =>
                                  handleFreightForwarderChange(
                                    manufacturingPlantTabIndex,
                                    'id',
                                    e.target.value.replace(/[^0-9]/g, '')
                                  )
                                }
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="Enter ID"
                                inputProps={{ maxLength: 20 }}
                              />
                            )}
                          </TableCell>
                          <TableCell style={{ borderRight: '1px solid #e0e0e0', verticalAlign: 'middle' }}>
                            {readOnly ? (
                              <Typography>
                                {manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.name || 'N/A'}
                              </Typography>
                            ) : (
                              <TextField
                                value={manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.name || ''}
                                onChange={(e) =>
                                  handleFreightForwarderChange(
                                    manufacturingPlantTabIndex,
                                    'name',
                                    e.target.value
                                  )
                                }
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="Enter Name"
                                inputProps={{ maxLength: 100 }}
                              />
                            )}
                          </TableCell>
                          <TableCell style={{ borderRight: '1px solid #e0e0e0', verticalAlign: 'middle' }}>
                            {readOnly ? (
                              <Typography style={{ wordBreak: 'break-all' }}>
                                {manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.portal || 'N/A'}
                              </Typography>
                            ) : (
                              <TextField
                                value={manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.portal || ''}
                                onChange={(e) =>
                                  handleFreightForwarderChange(
                                    manufacturingPlantTabIndex,
                                    'portal',
                                    e.target.value
                                  )
                                }
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="https://..."
                                inputProps={{ maxLength: 500 }}
                              />
                            )}
                          </TableCell>
                          <TableCell style={{ verticalAlign: 'middle' }}>
                            {readOnly ? (
                              <Typography>
                                {manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.billingCenter || 'N/A'}
                              </Typography>
                            ) : (
                              <TextField
                                value={manufacturingPlants[manufacturingPlantTabIndex].freightForwarder?.billingCenter || ''}
                                onChange={(e) =>
                                  handleFreightForwarderChange(
                                    manufacturingPlantTabIndex,
                                    'billingCenter',
                                    e.target.value.replace(/[^0-9]/g, '')
                                  )
                                }
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="Enter Billing Center"
                                inputProps={{ maxLength: 20 }}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                {/* BCM-3PL: Manufacturing Plant Details heading — placed AFTER the
                    Freight Forwarder table so the section order is tabs →
                    Freight Forwarder → Manufacturing Plant Details fields. */}
                <Typography
                  variant="h6"
                  style={{ fontWeight: 'bold', marginTop: '8px', marginBottom: '16px' }}
                >
                  Manufacturing Plant Details
                </Typography>

                <Grid className="two-col-forms-grid" container spacing={3}>
                  {/* Left Column */}
                  <Grid item xs={12} sm={6}>
                    {/* Site ID */}
                    <FormControl className={classes.formField} style={{ marginBottom: 24 }}>
                      <Typography component="label">
                        Site ID
                      </Typography>
                      <Typography style={{ padding: '14px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                        {manufacturingPlants[manufacturingPlantTabIndex].siteID || 'N/A'}
                      </Typography>
                    </FormControl>

                    {/* Manufacturing Plant ID */}
                    <FormControl className={classes.formField} style={{ marginBottom: 24 }}>
                      <Typography component="label">
                        Manufacturing Plant ID
                      </Typography>
                      <Typography style={{ padding: '14px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                        {manufacturingPlants[manufacturingPlantTabIndex].manufacturingPlantID || 'N/A'}
                      </Typography>
                    </FormControl>

                    {/* Line/Suite ID Fields */}
                    {manufacturingPlants[manufacturingPlantTabIndex].lineSuites && 
                     manufacturingPlants[manufacturingPlantTabIndex].lineSuites.map((lineSuite, lineIndex) => (
                      <FormControl key={lineIndex} className={classes.formField} style={{ marginBottom: 24 }}>
                        <Typography component="label">
                          Line/Suite ID
                        </Typography>
                        {readOnly ? (
                          <Typography style={{ padding: '14px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                            {lineSuite.lineSuiteID || 'N/A'}
                          </Typography>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', width: '100%' }}>
                            <TextField
                              value={lineSuite.lineSuiteID || ''}
                              onChange={(e) => handleLineSuiteChange(manufacturingPlantTabIndex, lineIndex, 'lineSuiteID', e.target.value)}
                              onBlur={(e) => {
                                // Always trim on blur to clean up leading/trailing spaces (while preserving middle spaces)
                                const trimmedValue = e.target.value.trim();
                                if (trimmedValue !== e.target.value) {
                                  handleLineSuiteChange(manufacturingPlantTabIndex, lineIndex, 'lineSuiteID', trimmedValue);
                                }
                              }}
                              variant="outlined"
                              placeholder="Enter text here"
                              fullWidth
                              error={Boolean(errors[`manufacturingPlant_${manufacturingPlantTabIndex}_lineSuite_${lineIndex}_lineSuiteID`])}
                              helperText={errors[`manufacturingPlant_${manufacturingPlantTabIndex}_lineSuite_${lineIndex}_lineSuiteID`] || ''}
                              InputProps={{ style: commonInlineStyles.input }}
                              sx={inputFieldStyles}
                              inputProps={{
                                ...commonInlineStyles.inputProps,
                                maxLength: 255
                              }}
                              style={commonInlineStyles.input}
                              onInput={(e) => {
                                e.target.value = e.target.value
                                  .replace(/[^a-zA-Z0-9\-_ ]/g, "")
                                  .replace(/(-{2,}|_{2,})/g, (match) => match[0]);
                              }}
                            />
                            <div style={{ width: '40px', flexShrink: 0, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', marginTop: '4px' }}>
                              {lineIndex > 0 && (
                                <IconButton
                                  onClick={() => handleRemoveLineSuite(manufacturingPlantTabIndex, lineIndex)}
                                  style={{ color: '#d32f2f', padding: '8px' }}
                                  size="small"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              )}
                            </div>
                          </div>
                        )}
                      </FormControl>
                    ))}

                    {/* Add New Line/Suite Button */}
                    {!readOnly && (
                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => handleAddLineSuite(manufacturingPlantTabIndex)}
                        style={{ marginTop: 8, textTransform: 'none' }}
                      >
                        Add New Line/Suite
                      </Button>
                    )}
                  </Grid>

                  {/* Right Column */}
                  <Grid item xs={12} sm={6}>
                    {/* Site Short Name */}
                    <FormControl className={classes.formField} style={{ marginBottom: 24 }}>
                      <Typography component="label">
                        Site Short Name
                      </Typography>
                      <Typography style={{ padding: '14px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                        {manufacturingPlants[manufacturingPlantTabIndex].siteShortName || 'N/A'}
                      </Typography>
                    </FormControl>

                    {/* Manufacturing Plant Short Name */}
                    <FormControl className={classes.formField} style={{ marginBottom: 24 }}>
                      <Typography component="label">
                        Manufacturing Plant Short Name
                      </Typography>
                      <Typography style={{ padding: '14px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                        {manufacturingPlants[manufacturingPlantTabIndex].manufacturingPlantShortName || 'N/A'}
                      </Typography>
                    </FormControl>

                    {/* Line/Suite Short Name Fields */}
                    {manufacturingPlants[manufacturingPlantTabIndex].lineSuites && 
                     manufacturingPlants[manufacturingPlantTabIndex].lineSuites.map((lineSuite, lineIndex) => (
                      <FormControl key={lineIndex} className={classes.formField} style={{ marginBottom: 24 }}>
                        <Typography component="label">
                          Line/Suite Short Name
                        </Typography>
                        {readOnly ? (
                          <Typography style={{ padding: '14px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                            {lineSuite.lineSuiteShortName || 'N/A'}
                          </Typography>
                        ) : (
                          <TextField
                            value={lineSuite.lineSuiteShortName || ''}
                            onChange={(e) => handleLineSuiteChange(manufacturingPlantTabIndex, lineIndex, 'lineSuiteShortName', e.target.value)}
                            onBlur={(e) => {
                              // Always trim on blur to clean up leading/trailing spaces (while preserving middle spaces)
                              const trimmedValue = e.target.value.trim();
                              if (trimmedValue !== e.target.value) {
                                handleLineSuiteChange(manufacturingPlantTabIndex, lineIndex, 'lineSuiteShortName', trimmedValue);
                              }
                            }}
                            variant="outlined"
                            placeholder="Enter text here"
                            fullWidth
                            InputProps={{ style: commonInlineStyles.input }}
                            sx={inputFieldStyles}
                            inputProps={{
                              ...commonInlineStyles.inputProps,
                              maxLength: 255
                            }}
                            style={commonInlineStyles.input}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/[^a-zA-Z0-9\-_ ]/g, "")
                                .replace(/(-{2,}|_{2,})/g, (match) => match[0]);
                            }}
                          />
                        )}
                      </FormControl>
                    ))}
                  </Grid>
                </Grid>
                </>
              )}
            </>
          ) : (
            <Typography style={{ marginBottom: 24, color: '#666' }}>
              No manufacturing plants available
            </Typography>
          )}

          {<Divider style={{ margin: "80px 0px 0px 0px", backgroundColor: '#707070', height: 1, zIndex: 4 }} />}
          {/* Main Address Section */}
          <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginTop: '40px', marginBottom: '16px' }}>
            Main Address Details
          </Typography>
          <Grid className="two-col-forms-grid" container spacing={3}>
            <Grid item xs={12} sm={6} className="multiple-line-text">
              <FormControl className={classes.formField} fullWidth>
                <Typography component="label" htmlFor="mainAddress.addressLine1">
                  Street Address 1 {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.mainAddress?.addressLine1 || getCurrentPlant()?.mainAddress?.addressLine1 || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="mainAddress.addressLine1"
                    name="mainAddress.addressLine1"
                    value={stepData.mainAddress?.addressLine1 || ''}
                    onChange={handleMainAddressChange('addressLine1')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={submitted && Boolean(errors['mainAddress.addressLine1'])}
                    helperText={submitted && errors['mainAddress.addressLine1']}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 255,
                    }}
                    style={commonInlineStyles.input}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-ZÀ-ÿ0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} className="multiple-line-text">
              <FormControl className={classes.formField} fullWidth>
                <Typography component="label" htmlFor="maiStreet Address 1nAddress.addressLine2">
                  Street Address 2 {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.mainAddress?.addressLine2 || getCurrentPlant()?.mainAddress?.addressLine2 || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="mainAddress.addressLine2"
                    name="mainAddress.addressLine2"
                    value={stepData.mainAddress?.addressLine2 || ''}
                    onChange={handleMainAddressChange('addressLine2')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={submitted && Boolean(errors['mainAddress.addressLine2'])}
                    helperText={submitted && errors['mainAddress.addressLine2']}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 255,
                    }}
                    style={commonInlineStyles.input}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-ZÀ-ÿ0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="mainAddress.country">
                  Country {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.mainAddress?.country || getCurrentPlant()?.mainAddress?.country || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="mainAddress.country"
                    name="mainAddress.country"
                    value={
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.mainAddress?.country
                      )?.isoCode || ''
                    }
                    onChange={handleCountryChange('mainAddress')}
                    variant="outlined"
                    placeholder="Select Country"
                    fullWidth
                    required
                    displayEmpty
                    error={submitted && Boolean(errors['mainAddress.country'])}
                    helperText={submitted && errors['mainAddress.country']}
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {Country.getAllCountries()?.map((country) => (
                      <MenuItem key={country.isoCode} value={country.isoCode}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="mainAddress.state">
                  State {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.mainAddress?.state || getCurrentPlant()?.mainAddress?.state || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="mainAddress.state"
                    name="mainAddress.state"
                    value={
                      State.getStatesOfCountry(
                        Country.getAllCountries().find(
                          (c) => c.name === stepData.mainAddress?.country
                        )?.isoCode || ''
                      ).find((s) => s.name === stepData.mainAddress?.state)?.isoCode || ''
                    }
                    onChange={handleStateChange('mainAddress')}
                    variant="outlined"
                    placeholder="Select State"
                    fullWidth
                    required
                    displayEmpty
                    disabled={!stepData.mainAddress?.country}
                    error={submitted && Boolean(errors['mainAddress.state'])}
                    helperText={submitted && errors['mainAddress.state']}
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {State.getStatesOfCountry(
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.mainAddress?.country
                      )?.isoCode || ''
                    ).map((state) => (
                      <MenuItem key={state.isoCode} value={state.isoCode}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="mainAddress.city">
                  City {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.mainAddress?.city || getCurrentPlant()?.mainAddress?.city || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="mainAddress.city"
                    name="mainAddress.city"
                    value={stepData.mainAddress?.city || ''}
                    onChange={handleCityChange('mainAddress')}
                    variant="outlined"
                    placeholder="Select City"
                    fullWidth
                    required
                    disabled={!stepData.mainAddress?.state}
                    error={submitted && Boolean(errors['mainAddress.city'])}
                    helperText={submitted && errors['mainAddress.city']}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {City.getCitiesOfState(
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.mainAddress?.country
                      )?.isoCode || '',
                      State.getStatesOfCountry(
                        Country.getAllCountries().find(
                          (c) => c.name === stepData.mainAddress?.country
                        )?.isoCode || ''
                      ).find((s) => s.name === stepData.mainAddress?.state)?.isoCode || ''
                    ).map((city) => (
                      <MenuItem key={city.name} value={city.name}>
                        {city.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="mainAddress.zipCode">
                  Post Code {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.mainAddress?.zipCode || getCurrentPlant()?.mainAddress?.zipCode || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="mainAddress.zipCode"
                    name="mainAddress.zipCode"
                    value={stepData.mainAddress?.zipCode || ''}
                    onChange={handlePostalCodeChange('mainAddress')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 12
                    }}
                    style={commonInlineStyles.input}
                    error={(Boolean(errors['mainAddress.zipCode']) || Boolean(postalCodeErrors.mainAddress))}
                    helperText={(errors['mainAddress.zipCode'] || postalCodeErrors.mainAddress)}
                  />
                )}
              </FormControl>
            </Grid>

          </Grid>
          {<Divider style={{ margin: "80px 0px 0px 0px", backgroundColor: '#707070', height: 1, zIndex: 4 }} />}
          {/* Pickup Address Section */}
          <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
            Pickup Address Details
          </Typography>
          <Grid className="two-col-forms-grid" container spacing={3}>
            <Grid item xs={12} sm={6} className="multiple-line-text">
              <FormControl className={classes.formField} fullWidth>
                <Typography component="label" htmlFor="pickupAddress.addressLine1">
                  Street Address 1 {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.pickupAddress?.addressLine1 || getCurrentPlant()?.pickupAddress?.addressLine1 || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="pickupAddress.addressLine1"
                    name="pickupAddress.addressLine1"
                    value={stepData.pickupAddress?.addressLine1 || ''}
                    onChange={handlePickupAddressChange('addressLine1')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={submitted && Boolean(errors['pickupAddress.addressLine1'])}
                    helperText={submitted && errors['pickupAddress.addressLine1']}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 255,
                    }}
                    style={commonInlineStyles.input}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-ZÀ-ÿ0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} className="multiple-line-text">
              <FormControl className={classes.formField} fullWidth>
                <Typography component="label" htmlFor="pickupAddress.addressLine2">
                  Street Address 2 {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.pickupAddress?.addressLine2 || getCurrentPlant()?.pickupAddress?.addressLine2 || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="pickupAddress.addressLine2"
                    name="pickupAddress.addressLine2"
                    value={stepData.pickupAddress?.addressLine2 || ''}
                    onChange={handlePickupAddressChange('addressLine2')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    multiline
                    rows={3}
                    error={submitted && Boolean(errors['pickupAddress.addressLine2'])}
                    helperText={submitted && errors['pickupAddress.addressLine2']}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 255,
                    }}
                    style={commonInlineStyles.input}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-ZÀ-ÿ0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="pickupAddress.country">
                  Country {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.pickupAddress?.country || getCurrentPlant()?.pickupAddress?.country || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="pickupAddress.country"
                    name="pickupAddress.country"
                    value={
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.pickupAddress?.country
                      )?.isoCode || ''
                    }
                    onChange={handleCountryChange('pickupAddress')}
                    variant="outlined"
                    placeholder="Select Country"
                    fullWidth
                    required
                    error={submitted && Boolean(errors['pickupAddress.country'])}
                    helperText={submitted && errors['pickupAddress.country']}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {Country.getAllCountries()?.map((country) => (
                      <MenuItem key={country.isoCode} value={country.isoCode}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="pickupAddress.state">
                  State {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.pickupAddress?.state || getCurrentPlant()?.pickupAddress?.state || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="pickupAddress.state"
                    name="pickupAddress.state"
                    value={
                      State.getStatesOfCountry(
                        Country.getAllCountries().find(
                          (c) => c.name === stepData.pickupAddress?.country
                        )?.isoCode || ''
                      ).find((s) => s.name === stepData.pickupAddress?.state)?.isoCode || ''
                    }
                    onChange={handleStateChange('pickupAddress')}
                    variant="outlined"
                    placeholder="Select State"
                    fullWidth
                    required
                    disabled={!stepData.pickupAddress?.country}
                    error={submitted && Boolean(errors['pickupAddress.state'])}
                    helperText={submitted && errors['pickupAddress.state']}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {State.getStatesOfCountry(
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.pickupAddress?.country
                      )?.isoCode || ''
                    ).map((state) => (
                      <MenuItem key={state.isoCode} value={state.isoCode}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="pickupAddress.city">
                  City {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.pickupAddress?.city || getCurrentPlant()?.pickupAddress?.city || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="pickupAddress.city"
                    name="pickupAddress.city"
                    value={stepData.pickupAddress?.city || ''}
                    onChange={handleCityChange('pickupAddress')}
                    variant="outlined"
                    placeholder="Select City"
                    fullWidth
                    required
                    disabled={!stepData.pickupAddress?.state}
                    error={submitted && Boolean(errors['pickupAddress.city'])}
                    helperText={submitted && errors['pickupAddress.city']}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {City.getCitiesOfState(
                      // Convert country name to isoCode
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.pickupAddress?.country
                      )?.isoCode || '',
                      // Convert state name to isoCode
                      State.getStatesOfCountry(
                        Country.getAllCountries().find(
                          (c) => c.name === stepData.pickupAddress?.country
                        )?.isoCode || ''
                      ).find((s) => s.name === stepData.pickupAddress?.state)?.isoCode || ''
                    ).map((city) => (
                      <MenuItem key={city.name} value={city.name}>
                        {city.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="pickupAddress.zipCode">
                  Post Code {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.pickupAddress?.zipCode || getCurrentPlant()?.pickupAddress?.zipCode || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="pickupAddress.zipCode"
                    name="pickupAddress.zipCode"
                    value={stepData.pickupAddress?.zipCode || ''}
                    onChange={handlePostalCodeChange('pickupAddress')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 12
                    }}
                    style={commonInlineStyles.input}
                    error={(Boolean(errors['pickupAddress.zipCode']) || Boolean(postalCodeErrors.pickupAddress))}
                    helperText={(errors['pickupAddress.zipCode'] || postalCodeErrors.pickupAddress)}
                  />
                )}
              </FormControl>
            </Grid>
          </Grid>
          {<Divider style={{ margin: "80px 0px 0px 0px", backgroundColor: '#707070', height: 1, zIndex: 4 }} />}

          {/* Delivery Address Section */}
          <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
            Delivery Address Details
          </Typography>
          <Grid className="two-col-forms-grid" container spacing={3}>
            <Grid item xs={12} sm={6} className="multiple-line-text">
              <FormControl className={classes.formField} fullWidth>
                <Typography component="label" htmlFor="deliveryAddress.addressLine1">
                  Street Address 1 {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.deliveryAddress?.addressLine1 || getCurrentPlant()?.deliveryAddress?.addressLine1 || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="deliveryAddress.addressLine1"
                    name="deliveryAddress.addressLine1"
                    value={stepData.deliveryAddress?.addressLine1 || ''}
                    onChange={handleDeliveryAddressChange('addressLine1')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={submitted && Boolean(errors['deliveryAddress.addressLine1'])}
                    helperText={submitted && errors['deliveryAddress.addressLine1']}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 255,
                    }}
                    style={commonInlineStyles.input}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-ZÀ-ÿ0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} className="multiple-line-text">
              <FormControl className={classes.formField} fullWidth>
                <Typography component="label" htmlFor="deliveryAddress.addressLine2">
                  Street Address 2 {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.deliveryAddress?.addressLine2 || getCurrentPlant()?.deliveryAddress?.addressLine2 || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="deliveryAddress.addressLine2"
                    name="deliveryAddress.addressLine2"
                    value={stepData.deliveryAddress?.addressLine2 || ''}
                    onChange={handleDeliveryAddressChange('addressLine2')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={submitted && Boolean(errors['deliveryAddress.addressLine2'])}
                    helperText={submitted && errors['deliveryAddress.addressLine2']}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 255,
                    }}
                    style={commonInlineStyles.input}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-ZÀ-ÿ0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="deliveryAddress.country">
                  Country {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.deliveryAddress?.country || getCurrentPlant()?.deliveryAddress?.country || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="deliveryAddress.country"
                    name="deliveryAddress.country"
                    value={
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.deliveryAddress?.country
                      )?.isoCode || ''
                    }
                    onChange={handleCountryChange('deliveryAddress')}
                    variant="outlined"
                    placeholder="Select Country"
                    fullWidth
                    required
                    error={submitted && Boolean(errors['deliveryAddress.country'])}
                    helperText={submitted && errors['deliveryAddress.country']}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {Country.getAllCountries()?.map((country) => (
                      <MenuItem key={country.isoCode} value={country.isoCode}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="deliveryAddress.state">
                  State {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.deliveryAddress?.state || getCurrentPlant()?.deliveryAddress?.state || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="deliveryAddress.state"
                    name="deliveryAddress.state"
                    value={
                      State.getStatesOfCountry(
                        Country.getAllCountries().find(
                          (c) => c.name === stepData.deliveryAddress?.country
                        )?.isoCode || ''
                      ).find((s) => s.name === stepData.deliveryAddress?.state)?.isoCode || ''
                    }
                    onChange={handleStateChange('deliveryAddress')}
                    variant="outlined"
                    placeholder="Select State"
                    fullWidth
                    required
                    disabled={!stepData.deliveryAddress?.country}
                    error={submitted && Boolean(errors['deliveryAddress.state'])}
                    helperText={submitted && errors['deliveryAddress.state']}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {State.getStatesOfCountry(
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.deliveryAddress?.country
                      )?.isoCode || ''
                    ).map((state) => (
                      <MenuItem key={state.isoCode} value={state.isoCode}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="deliveryAddress.city">
                  City {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.deliveryAddress?.city || getCurrentPlant()?.deliveryAddress?.city || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="deliveryAddress.city"
                    name="deliveryAddress.city"
                    value={stepData.deliveryAddress?.city || ''}
                    onChange={handleCityChange('deliveryAddress')}
                    variant="outlined"
                    placeholder="Select City"
                    fullWidth
                    required
                    disabled={!stepData.deliveryAddress?.state}
                    error={submitted && Boolean(errors['deliveryAddress.city'])}
                    helperText={submitted && errors['deliveryAddress.city']}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {City.getCitiesOfState(
                      // Convert country name to isoCode
                      Country.getAllCountries().find(
                        (c) => c.name === stepData.deliveryAddress?.country
                      )?.isoCode || '',
                      // Convert state name to isoCode
                      State.getStatesOfCountry(
                        Country.getAllCountries().find(
                          (c) => c.name === stepData.deliveryAddress?.country
                        )?.isoCode || ''
                      ).find((s) => s.name === stepData.deliveryAddress?.state)?.isoCode || ''
                    ).map((city) => (
                      <MenuItem key={city.name} value={city.name}>
                        {city.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="deliveryAddress.zipCode">
                  Post Code {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData.deliveryAddress?.zipCode || getCurrentPlant()?.deliveryAddress?.zipCode || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="deliveryAddress.zipCode"
                    name="deliveryAddress.zipCode"
                    value={stepData.deliveryAddress?.zipCode || ''}
                    onChange={handlePostalCodeChange('deliveryAddress')}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{
                      ...commonInlineStyles.inputProps,
                      maxLength: 12
                    }}
                    style={commonInlineStyles.input}
                    error={(Boolean(errors['deliveryAddress.zipCode']) || Boolean(postalCodeErrors.deliveryAddress))}
                    helperText={(errors['deliveryAddress.zipCode'] || postalCodeErrors.deliveryAddress)}
                  />
                )}
              </FormControl>
            </Grid>
          </Grid>
          {/* //Plant Configuration */}
          {<Divider style={{ margin: "80px 0px 0px 0px", backgroundColor: '#707070', height: 1, zIndex: 4 }} />}
          <Typography variant="h6" className={`plant-config-heading ${classes.formTitle}`}>
            Manufacturing Plant Configurations
          </Typography>
          {!readOnly && <>
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              style={{ marginBottom: 16 }}
            >
              <Tab label={`Product Modality (${drugTypes.length})`} className={classes.tabLabel} classes={{ root: classes.tabRoot }} />
              <Tab label={`Manufacturing Supply Type (${supplyTypes.length})`} className={classes.tabLabel} classes={{ root: classes.tabRoot }} />
              <Tab label={`Plant Type (${plantTypes.length})`} className={classes.tabLabel} classes={{ root: classes.tabRoot }} />
              <Tab label={`Manufacturing Plant Type (${facilityTypes.length})`} className={classes.tabLabel} classes={{ root: classes.tabRoot }} />
            </Tabs>

            <div className={classes.tabContentContainer}>
              {renderTabContent()}
            </div>
          </>}


          {/* Note for user */}
          {!readOnly &&
            <Typography style={{ marginTop: 50, color: '#444', fontSize: 16 }}>
              <b>Note -</b><br />
              Please view the content from all the tabs before proceeding to the next step.
            </Typography>
          }

          {
            readOnly && <div className="read-only-tab-content">
              {tabsLoading ? (
                <div className={classes.loaderContainer}>
                  <CircularProgress color="primary" />
                </div>
              ) : (
                <>
                  {/* <Typography variant="h6" style={{marginBottom: '20px'}}>Product Modality</Typography> */}
                  <ProductModalityTab
                    drugTypes={drugTypes}
                    selectedConfigs={selectedConfigs.productModality || []}
                    onToggle={() => { }}
                    readOnly={readOnly}
                    isLoading={tabsLoading}
                  />

                  {/* <Typography variant="h6" style={{marginTop: '40px', marginBottom: '20px'}}>Manufacturing Supply Type</Typography> */}
                  <ManufacturingSupplyTypeTab
                    supplyTypes={supplyTypes}
                    selectedConfigs={selectedConfigs.manufacturingSupplyType || []}
                    onToggle={() => { }}
                    readOnly={readOnly}
                    isLoading={tabsLoading}
                  />

                  {/* <Typography variant="h6" style={{marginTop: '40px', marginBottom: '20px'}}>Plant Type</Typography> */}
                  <PlantTypeTab
                    plantTypes={plantTypes}
                    selectedConfigs={selectedConfigs.plantType || []}
                    onToggle={() => { }}
                    readOnly={readOnly}
                    isLoading={tabsLoading}
                  />

                  {/* <Typography variant="h6" style={{marginTop: '40px', marginBottom: '20px'}}>Manufacturing Plant Type</Typography> */}
                  <ManufacturingPlantTypeTab
                    facilityTypes={facilityTypes}
                    selectedConfigs={selectedConfigs.manufacturingPlantType || []}
                    onToggle={() => { }}
                    readOnly={readOnly}
                    isLoading={tabsLoading}
                  />
                </>
              )}
            </div>
          }

          {!hideStepActions && <div className="stepper-navigation-btns" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32 }}>
            <Button startIcon={<ArrowBackIosIcon />} variant="outlined" color="default" onClick={handleBack} className={classes.backButton}>
              Back
            </Button>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNextClick}
                className={classes.button}
                endIcon={loading ? <CircularProgress size={20} /> : <ArrowForwardIosIcon />}
                disabled={loading || tabsLoading || !tabsVisited.every(Boolean)}
              >
                {loading 
                  ? "Saving..." 
                  : (manufacturingPlantTabIndex === manufacturingPlants.length - 1)
                    ? "Save & Next"
                    : "Save & Next MFG tab"}
              </Button>
              {/* {!tabsVisited.every(Boolean) && (
                <Typography color="error" style={{ marginTop: 8, fontSize: 14 }}>
                  Please view the content from all the tabs before proceeding to the next step.
                </Typography>
              )} */}
            </div>
          </div>}
        </form>
        {readOnly && <Divider style={{ margin: "80px 00px 0px 00px", backgroundColor: '#707070', height: 1, }} />}
      </div>
    </div>
  );
};

export default PlantDetails;